/**
 * Load flat database
 * @param cb
 */

(function ($) {
  "use strict";

  $.cordiaFlatDbDone = $.Deferred();

  Storage.prototype.setObj = function (key, obj) {
    return this.setItem(key, JSON.stringify(obj));
  };
  Storage.prototype.getObj = function (key) {
    return JSON.parse(this.getItem(key));
  };

  const paginationNumbers = document.getElementById("pagination-numbers");
  let currentPage = 1;

  const handleActivePageNumber = () => {
    document.querySelectorAll(".pagination-number").forEach((button) => {
      button.classList.remove("active");
      const pageIndex = Number(button.getAttribute("page-index"));
      if (pageIndex == currentPage) {
        button.classList.add("active");
      }
    });
  };

  $(document).on(
    "change",
    ".dropdown__inner>li>.checkbox-group>.checkbox-item",
    function () {
      const dropdown = $(this).closest(".dropdown");
      const dropdownLabel = $(dropdown).prev().text();
      const dropdownTitle = $(dropdown).find(".dropdown__title");
      const group = $(this).closest(".checkbox-group");

      let checked = [];

      $(group)
        .find("input:checked")
        .each(function () {
          checked.push($(this).next().text());
        });

      let title = dropdownLabel;

      $(dropdownTitle).removeClass("selected");

      if (checked.length) {
        $(dropdownTitle).addClass("selected");

        if (checked.length === 1) {
          title = checked[0];
        }

        if (checked.length > 1) {
          title = checked.length + " " + localize.translations.selected;
        }
      }

      $(dropdownTitle).text(title);
    },
  );

  $(document).on("click", ".checkbox-item", function (e) {
    const checkBox = $(this).find(".flatSelector");

    $(checkBox).prop("checked", !checkBox.prop("checked")).change();
  });

  const appendPageNumber = (index, pageCount, currentPage) => {
    const pageNumber = document.createElement("button");
    pageNumber.className = "pagination-number";
    pageNumber.innerHTML = index;
    pageNumber.setAttribute("page-index", index);
    pageNumber.setAttribute("aria-label", "Page " + index);

    $(pageNumber).on("click", function () {
      if (currentPage === index) {
        return false;
      }

      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set("pg", index);

      // Scroll target:
      // - default: page top
      // - on agents portal project single: top of the .single-agent-flats-search section
      let targetTop = 0;
      const $agentSection = $(".single-agent-flats-search");

      if ($agentSection.length) {
        let offset = $agentSection.offset().top;
        let totalOffset = 0;
        const $wpAdminBar = $(".wpadminbar");
        const $header = $(".header--agents-portal");
        const $nav = $(".project-single__navigation");

        if ($wpAdminBar.length) {
          totalOffset += $wpAdminBar.outerHeight();
        }
        if ($header.length) {
          totalOffset += $header.outerHeight();
        }
        if ($nav.length) {
          totalOffset += $nav.outerHeight();
        }

        targetTop = offset - totalOffset - 60;
      }

      window.scrollTo({ top: targetTop, behavior: "smooth" });
      let newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        searchParams.toString().replaceAll(/\+/g, "%20");
      window.history.pushState({ path: newurl }, "", newurl);
      $.lakaskereso.updateDomFlatlist();
    });

    paginationNumbers.appendChild(pageNumber);
  };

  const appendDots = () => {
    const pageNumber = document.createElement("span");
    pageNumber.className = "pagination-dots";
    pageNumber.innerHTML = "...";
    paginationNumbers.appendChild(pageNumber);
  };

  const addArrows = (currentPage, pageCount, prev = true) => {
    const index = prev ? currentPage - 1 : currentPage + 1;
    const button = document.createElement("button");
    button.className = "pagination-number chevron";
    button.innerHTML = prev
      ? '<img alt="chevron-left" src="' +
        localize.themeurl +
        '/assets/img/svg/chevron/chevron-left.svg">'
      : '<img alt="chevron-left" src="' +
        localize.themeurl +
        '/assets/img/svg/chevron/chevron-right.svg">';

    if (prev && currentPage === 1) {
      button.classList.add("disabled");
      button.setAttribute("disabled", true);
    }

    if (!prev && currentPage === pageCount) {
      button.classList.add("disabled");
      button.setAttribute("disabled", true);
    }

    $(button).on("click", function () {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set("pg", index);

      // Scroll target:
      // - default: page top
      // - on agents portal project single: top of the .single-agent-flats-search section
      let targetTop = 0;
      const $agentSection = $(".single-agent-flats-search");

      if ($agentSection.length) {
        let offset = $agentSection.offset().top;
        let totalOffset = 0;
        const $wpAdminBar = $(".wpadminbar");
        const $header = $(".header--agents-portal");
        const $nav = $(".project-single__navigation");

        if ($wpAdminBar.length) {
          totalOffset += $wpAdminBar.outerHeight();
        }
        if ($header.length) {
          totalOffset += $header.outerHeight();
        }
        if ($nav.length) {
          totalOffset += $nav.outerHeight();
        }

        targetTop = offset - totalOffset - 60;
      }

      window.scrollTo({ top: targetTop, behavior: "smooth" });
      let newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        searchParams.toString();
      window.history.pushState({ path: newurl }, "", newurl);
      $.lakaskereso.updateDomFlatlist();
    });

    paginationNumbers.appendChild(button);
  };

  const getMobilePagination = (pageCount, currentPage) => {
    paginationNumbers.innerHTML = "";
    addArrows(currentPage, pageCount, true);
    appendPageNumber(currentPage, pageCount, currentPage);
    const slash = document.createElement("span");
    slash.className = "pagination-slash";
    slash.innerHTML = "/";
    paginationNumbers.appendChild(slash);
    appendPageNumber(pageCount, pageCount, currentPage);
    addArrows(currentPage, pageCount, false);
  };

  const getPaginationNumbers = (pageCount, currentPage) => {
    paginationNumbers.innerHTML = "";
    const pageRange = 1;

    if (pageCount <= 1) {
      return;
    }

    addArrows(currentPage, pageCount, true);
    appendPageNumber(1, pageCount, currentPage);

    if (currentPage <= pageCount - pageRange) {
      let lastIndex = 1;
      let noDots = true;

      for (let i = currentPage - pageRange; i <= currentPage + pageRange; i++) {
        if (i < pageCount && i > 1) {
          if (i > 3 && noDots) {
            appendDots();
          }

          noDots = false;
          lastIndex = i;
          appendPageNumber(i, pageCount, currentPage);
        }
      }

      if (lastIndex < pageCount - 1) {
        appendDots();
      }
    } else {
      for (let i = pageCount - pageRange; i <= pageCount; i++) {
        let noDots = true;

        if (i < pageCount && i > 1) {
          if (i > 2 && noDots) {
            appendDots();
          }
          noDots = false;

          appendPageNumber(i, pageCount, currentPage);
        }
      }
    }
    appendPageNumber(pageCount, pageCount, currentPage);
    addArrows(currentPage, pageCount, false);
  };

  const setCurrentPage = (pageNum) => {
    currentPage = pageNum;
    handleActivePageNumber();
  };

  function compareFlatsByProjectOrder(a, b) {
    const projectOrder = {
      a025800000GRxUfAAL: 2,
      a025800000PF1KLAA1: 1,
      a025800000LggOhAAJ: 0,
      a025800000PFvXiAAL: -1,
      a025800000V4uRYAAZ: -2,
      a025800000T8ud9AAB: -3,
      a024H00000nHmpgQAC: -4,
      a025800000NbR3QAAV: -5,
      a024H00000e97LMQAY: -6,
      a025800000NbR4JAAV: -7,
      a025800000PFvXYAA1: -8,
      a0258000003E0EQAA0: -9,
      a025800000EzqNyAAJ: -10,
      a025800000LeykDAAR: -11,
      a025800000FNkckAAD: -12,
      a025800000H10jGAAR: -13,
      a02580000027h8XAAQ: -14,
      a023L000002MhzfQAC: -15,
    };

    if (
      projectOrder[a.project_id] !== undefined &&
      projectOrder[b.project_id] === undefined
    ) {
      return -1;
    }

    if (
      projectOrder[a.project_id] === undefined &&
      projectOrder[b.project_id] !== undefined
    ) {
      return 1;
    }

    if (
      projectOrder[a.project_id] === undefined &&
      projectOrder[b.project_id] === undefined
    ) {
      return 0;
    }

    if (projectOrder[a.project_id] > projectOrder[b.project_id]) {
      return -1;
    }

    return 0;
  }

  $.loadFlatDB = function loadFlatDB(cb) {
    //cache DB calls
    if (window.cordia_flat_db) {
      return cb(window.cordia_flat_db);
    }

    var toExcludeProject = [];
    var toExcludeResidential = [];
    var type = false;
    var azonnal = false;
    var segments = [];
    var sasadmod = false;
    if ($(".js-search-widget-mod").length) {
      sasadmod = true;
    }

    var $tResidential = $(".t-residential");
    if (
      $tResidential.length &&
      $tResidential.data("showflatlist") != undefined
    ) {
      var dataProjects = $tResidential.data("projects");

      // If data-projects exists, use it directly (specific projects, not family)
      if (
        dataProjects &&
        Array.isArray(dataProjects) &&
        dataProjects.length > 0
      ) {
        type = "include";
        toExcludeProject = dataProjects; // Use project IDs directly
      }
      // Otherwise, fall back to the old behavior (filter by lakopark/family)
      else if ($tResidential.data("project")) {
        for (var key in localize.residentials) {
          if (
            localize.residentials[key].lakopark_id ==
            $tResidential.data("project").toString()
          ) {
            type = "include";
            toExcludeProject.push(key);
            toExcludeResidential.push(localize.residentials[key].lakopark_id);
          }
        }
      }
    } else {
      for (var key in localize.residentials) {
        if (localize.residentials[key].exclude == true) {
          type = "exclude";
          toExcludeProject.push(key);
          toExcludeResidential.push(localize.residentials[key].lakopark_id);
        }
      }
    }

    const url = new URL(window.location.href);
    const keys = Array.from(url.searchParams.keys());

    let token = false;
    if (keys.length > 0) {
      token = keys[0];
    }

    $.getJSON(
      localize.apiendpoint + "/sf/getflatdb",
      {
        lang: $.langCookie,
        excludeproject: toExcludeProject,
        excluderesidential: toExcludeResidential,
        type: type,
        azonnal: azonnal,
        segments: segments,
        sasadmod: sasadmod,
        token: token,
      },
      function (result) {
        window.cordia_flat_db = result;
        $.cordiaFlatDbDone.resolve();
        cb(result);
      },
    );
  };

  $.convertNeighbourhoodName = function convertNeighbourhoodName(str) {
    if (str == null) {
      str = "-";
    } else {
      if ($.langCookie === "en") {
        str = str.replace("Belvárosi", "Downtown");
        str = str.replace("Vízparti", "Waterside");
        str = str.replace("Zöldövezeti", "Greenbelt");
        str = str.replace("Tengerparti", "Seaside");
        str = str.replace("Golfpálya", "Golf Course");
      }
    }

    return str;
  };

  $.convertViewName = function convertViewName(str) {
    if (str == null) {
      str = "-";
    } else {
      if ($.langCookie === "en") {
        str = str.replace("kertre néző", "Garden view");
        str = str.replace("utcára néző", "Street view");
        str = str.replace("udvarra néző", "Courtyard view");
        str = str.replace("panorámás", "With panorama");
      }
    }

    return str;
  };

  $.convertOrientation = function convertOrientation(str) {
    if (str == null) {
      str = "-";
    } else {
      if ($.langCookie === "en") {
        str = str.replace("Északi", "Northern");
        str = str.replace("Déli", "Southern");
        str = str.replace("Keleti", "Eastern");
        str = str.replace("Nyugati", "Western");
      }
    }

    return str;
  };

  $.shortenLakasUrl = function shortenLakasUrl(url) {
    if (typeof url !== "object") {
      return url;
    }

    var res = [];

    if (typeof url["szoba"] !== "undefined") {
      res.push(["r", url["szoba"][0] + "-" + url["szoba"][1]]);
    }

    if (typeof url["terulet"] !== "undefined") {
      res.push(["a", url["terulet"][0] + "-" + url["terulet"][1]]);
    }

    if (typeof url["buda"] !== "undefined") {
      var b_value;
      if (url["buda"] == "kulfold") {
        b_value = 2;
      } else if (url["buda"] == true) {
        b_value = 1;
      } else if (url["buda"] == false) {
        b_value = 0;
      } else {
        b_value = undefined;
      }
      res.push(["b", b_value]);
    }

    if (typeof url["kornyezet"] !== "undefined") {
      res.push([
        "k",
        url["kornyezet"]
          .map((e) => encodeURIComponent(e))
          .sort()
          .join("_"),
      ]);
    }

    if (typeof url["kerulet"] !== "undefined") {
      res.push(["d", url["kerulet"].join(",")]);
    }

    if (typeof url["lakopark"] !== "undefined") {
      res.push([
        "p",
        url["lakopark"]
          .map((e) => {
            e = e.toString();
            // Prefix numeric-only values to avoid WordPress redirect
            if (/^\d+/.test(e)) {
              e = "id-" + e;
            }
            return encodeURIComponent(e);
          })
          .sort()
          .join("_"),
      ]);
    }

    if (typeof url["kertkapcsolatos"] !== "undefined") {
      res.push([
        "g",
        url["kertkapcsolatos"]
          .map((e) => encodeURIComponent(e))
          .sort()
          .join("_"),
      ]);
    }

    if (typeof url["emelet"] !== "undefined") {
      res.push(["e", url["emelet"].join(",")]);
    }

    if (typeof url["terasz"] !== "undefined") {
      res.push(["t", url["terasz"][0] + "-" + url["terasz"][1]]);
    }

    if (typeof url["kilatas"] !== "undefined") {
      res.push([
        "view",
        url["kilatas"]
          .map((e) => encodeURIComponent(e))
          .sort()
          .join("_"),
      ]);
    }

    if (typeof url["tajolas_web"] !== "undefined") {
      res.push([
        "f",
        url["tajolas_web"]
          .map((e) => encodeURIComponent(e))
          .sort()
          .join("_"),
      ]);
    }

    if (typeof url["energiatakarekos"] !== "undefined") {
      res.push(["ee", "1"]);
    }

    if (typeof url["kedvezmenyes"] !== "undefined") {
      res.push(["kl", "1"]);
    }

    if (typeof url["azonnal_koltozheto"] !== "undefined") {
      res.push(["ip", "1"]);
    }

    if (url["sort"]["by"]) {
      res.push(["o", encodeURIComponent(url["sort"]["by"])]);
    }

    if (!url["sort"]["asc"]) {
      res.push(["asc", 1]);
    }

    if (typeof url["pg"] !== "undefined") {
      res.push(["pg"], url["pg"]);
    }

    return res.map((e) => e.join("=")).join("&");
  };

  $.getPage = function (queryString) {
    if (typeof queryString !== "string") {
      return 1;
    }

    const urlParams = new URLSearchParams(queryString);
    const page = parseInt(urlParams.get("pg")) || 1;

    return page;
  };

  $.deshortenLakasUrl = function deshortenLakasUrl(url) {
    if (typeof url !== "string") {
      return url;
    }

    url = url.split("&");
    var res = {};

    url.forEach((u) => {
      u = u.split("=");
      if (u.length != 2) {
        return;
      }

      if (u[0] == "r") {
        return (res["szoba"] = u[1].split("-").map((e) => parseInt(e)));
      }
      if (u[0] == "a") {
        return (res["terulet"] = u[1].split("-").map((e) => parseInt(e)));
      }
      if (u[0] == "b") {
        if (u[1] === "1") {
          res["buda"] = true;
        } else if (u[1] === "2") {
          res["buda"] = "kulfold";
        } else if (u[1] === "0") {
          res["buda"] = false;
        } else {
          res["buda"] = undefined;
        }
        return res["buda"];
      }
      if (u[0] == "k") {
        return (res["kornyezet"] = u[1]
          .split("_")
          .map((e) => decodeURIComponent(e)));
      }
      if (u[0] == "g") {
        return (res["kertkapcsolatos"] = u[1]
          .split("_")
          .map((e) => decodeURIComponent(e)));
      }
      if (u[0] == "d") {
        return (res["kerulet"] = u[1].split(",").map((e) => parseInt(e)));
      }
      if (u[0] == "p") {
        if ($(".js-search-widget-mod").length) {
          if (decodeURIComponent(u[1]) == "Sasad Resort") {
            u[1] =
              "Sasad%20Resort%20Panorama_Sasad%20Resort%20Sunlight_Sasad%20Resort%20Sunrise";
          }
        }
        return (res["lakopark"] = u[1].split("_").map((e) => {
          e = decodeURIComponent(e);
          // Remove prefix if exists
          return e.startsWith("id-") ? e.slice(3) : e;
        }));
      }
      if (u[0] == "e") {
        return (res["emelet"] = u[1].split(",").map((e) => parseInt(e)));
      }
      if (u[0] == "t") {
        return (res["terasz"] = u[1].split("-").map((e) => parseInt(e)));
      }

      if (u[0] == "f") {
        return (res["tajolas_web"] = u[1]
          .split("_")
          .map((e) => decodeURIComponent(e)));
      }

      if (u[0] == "view") {
        return (res["kilatas"] = u[1]
          .split("_")
          .map((e) => decodeURIComponent(e)));
      }

      if (u[0] == "ee") {
        return (res["energiatakarekos"] = "1");
      }

      if (u[0] == "kl") {
        return (res["kedvezmenyes"] = "1");
      }

      if (u[0] == "ip") {
        return (res["azonnal_koltozheto"] = "1");
      }

      if (u[0] == "o") {
        if (!res["sort"]) {
          res["sort"] = {};
        }
        return (res["sort"]["by"] = decodeURIComponent(u[1]));
      }

      if (u[0] == "asc") {
        if (!res["sort"]) {
          res["sort"] = {};
        }
        return (res["sort"]["asc"] = false);
      }

      if (u[0] == "pg") {
        return (res["pg"] = u[1]);
      }
    });
    return res;
  };

  $.onlyUnique = function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  };

  $.getSpIdsByPageId = function getSpIdsByPageId(pageId) {
    return Object.values(localize.residentials)
      .filter((residential) => residential.id === pageId)
      .map((residential) => residential.sp_id);
  };

  $.findObjectByKey = function findObjectByKey(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if ($(".js-search-widget-mod").length) {
        var temp = array[i][key];
        temp = temp.toString();
        temp = temp.split("_");

        if (temp[1] != undefined) {
          var data_id = $("main").data("id");
          if (data_id != undefined) {
            var p_nev = Object.values(localize.residentials).find(
              (e) => e.id == data_id,
            ).projekt_nev;
            return array.find((e) => e["nev"].trim() == p_nev.trim());
          }
        } else {
          if (temp[0] === value) {
            return array[i];
          }
        }
      } else {
        if (array[i][key] == value) {
          return array[i];
        }
      }
    }
    return null;
  };

  $("#energy").on("change", function () {
    if ($(this).prop("checked")) {
      $.lakaskereso.setFilter("energiatakarekos", true);
    } else {
      $.lakaskereso.setFilter("energiatakarekos", undefined);
    }
  });

  $("#discounted").on("change", function () {
    if ($(this).prop("checked")) {
      $.lakaskereso.setFilter("kedvezmenyes", true);
      $("#discounted2").prop("checked", true);
    } else {
      $.lakaskereso.setFilter("kedvezmenyes", undefined);
      $("#discounted2").prop("checked", false);
    }
  });

  $(document).on("change", "#discounted2", function () {
    if ($(this).prop("checked")) {
      $.lakaskereso.setFilter("kedvezmenyes", true);
      $("#discounted").prop("checked", true);
    } else {
      $.lakaskereso.setFilter("kedvezmenyes", undefined);
      $("#discounted").prop("checked", false);
    }
  });

  $("#immediet_pos").on("change", function () {
    if ($(this).prop("checked")) {
      $.lakaskereso.setFilter("azonnal_koltozheto", true);
    } else {
      $.lakaskereso.setFilter("azonnal_koltozheto", undefined);
    }
  });

  function replaceDiacritics(str) {
    var diacritics = [
      {
        char: "A",
        base: /[\300-\306]/g,
      },
      {
        char: "a",
        base: /[\340-\346]/g,
      },
      {
        char: "E",
        base: /[\310-\313]/g,
      },
      {
        char: "e",
        base: /[\350-\353]/g,
      },
      {
        char: "I",
        base: /[\314-\317]/g,
      },
      {
        char: "i",
        base: /[\354-\357]/g,
      },
      {
        char: "O",
        base: /[\322-\330]/g,
      },
      {
        char: "o",
        base: /[\362-\370]/g,
      },
      {
        char: "U",
        base: /[\331-\334]/g,
      },
      {
        char: "u",
        base: /[\371-\374]/g,
      },
      {
        char: "N",
        base: /[\321]/g,
      },
      {
        char: "n",
        base: /[\361]/g,
      },
      {
        char: "C",
        base: /[\307]/g,
      },
      {
        char: "c",
        base: /[\347]/g,
      },
    ];

    diacritics.forEach(function (letter) {
      str = str.replace(letter.base, letter.char);
    });

    return str;
  }

  /**
   * Remove any non english character from a string
   * @param complextag
   * @returns {string}
   */
  function mapToSimpleTag(complextag) {
    return replaceDiacritics(complextag.toLowerCase());
    //return complextag.toLowerCase().replace(/[^a-zA-Z0-9-_]/g, '');
  }

  var romanMatrix = [
    [10, "X"],
    [9, "IX"],
    [5, "V"],
    [4, "IV"],
    [1, "I"],
  ];

  function convertToRoman(num) {
    if (num === 0) {
      return "";
    }
    for (var i = 0; i < romanMatrix.length; i++) {
      if (num >= romanMatrix[i][0]) {
        return romanMatrix[i][1] + convertToRoman(num - romanMatrix[i][0]);
      }
    }
  }

  function pestOrBuda(d) {
    if ($.inArray(d, ["1", "2", "3", "11", "12", "22"]) > -1) {
      return "(Buda)";
    }
    if ($.inArray(d, ["ES"]) > -1) {
      return `(${localize.translations.abroad})`;
    }
    return "(Pest)";
  }

  function keresoAddKert(parent, currentFilterCb, filterCb) {
    var wrapper = $(`<div class="radio-button-group"></div>`);

    // $(wrapper).prepend(`<label>${localize.translations.kertkapcsolatos}</label>`);
    $('<li class="dropdown"></li>')
      .appendTo(parent)
      .append(
        `<label class="dropdown-label">${localize.translations.kertkapcsolatos}</label>`,
      )
      .append(wrapper);
    var currentset = currentFilterCb();

    /* Both */
    var both = $(
      '<input id="both-kertkapcsolatos" name="kertkapcsolatos-kertkapcsolatos" type="radio">',
    );

    if (currentset === undefined) {
      both.prop("checked", true);
    }

    both.change(() => {
      delete $.lakaskereso.filters.utem;
      filterCb(undefined);
    });

    $('<span class="radio-button-item"></span>')
      .appendTo(wrapper)
      .append(both, [
        $(
          `<label for="both-kertkapcsolatos" class="control-label checkbox-label">${localize.translations.flatSearchAll}</label>`,
        ),
      ]);

    /* Kertkapcsolatos */
    var kertkapcsolatos = $(
      '<input id="kertkapcsolatos-kertkapcsolatos" name="kertkapcsolatos-kertkapcsolatos" type="radio">',
    );
    if (currentset === true) {
      kertkapcsolatos.prop("checked", true);
    }
    kertkapcsolatos.change(() => {
      delete $.lakaskereso.filters.utem;
      filterCb(true);
    });

    $('<span class="radio-button-item"></span>')
      .appendTo(wrapper)
      .append(kertkapcsolatos, [
        $(
          `<label for="kertkapcsolatos-kertkapcsolatos" class="control-label checkbox-label">${localize.translations.flatSearchYes}</label>`,
        ),
      ]);

    /* Nem kertkapcsolatos */
    var nemKertkapcsolatos = $(
      '<input id="nem-kertkapcsolatos-kertkapcsolatos" name="kertkapcsolatos-kertkapcsolatos" type="radio">',
    );
    if (currentset === false) {
      nemKertkapcsolatos.prop("checked", true);
    }
    nemKertkapcsolatos.change(() => {
      delete $.lakaskereso.filters.utem;
      filterCb(false);
    });

    $('<span class="radio-button-item"></span>')
      .appendTo(wrapper)
      .append(nemKertkapcsolatos, [
        $(
          `<label for="nem-kertkapcsolatos-kertkapcsolatos" class="control-label checkbox-label">${localize.translations.flatSearchNo}</label>`,
        ),
      ]);
  }

  /**
   * Add a checkbox block to the filter
   * @param parent parent dom element
   * @param currentFilterCb get the current filter values
   * @param filterCb filter callback
   * @param options options as a list
   * @param label label above the filter
   * @param key key for the prefix for elements
   * @param mapOptToLabel map the option value to label
   * @param in_wrapper if dropdown needed
   */
  function keresoAddCheckboxes(
    parent,
    currentFilterCb,
    filterCb,
    options,
    label,
    key,
    mapOptToLabel,
    in_wrapper = true,
    addLabel = false,
  ) {
    //label
    var currentset = currentFilterCb();

    var innerWrapper = $(`<div class="checkbox-group"></div>`);

    if (in_wrapper) {
      var outerWrapper = $(`<li class="detailed-dropdown">
                <label class="dropdown-label">${label}</label>
                <div class="dropdown dropdown--light">
                <span class="dropdown__title">${label}</span>
                <ul class="dropdown__inner">
                    <li></li>
                </ul>

                </div>
            </li>`).appendTo(parent);
    } else {
      var outerWrapper = $(`<li class="dropdown in_wrapper-dropdown">
            </li>`).appendTo(parent);
      $(outerWrapper).prepend(`<label class="dropdown-label">${label}</label>`);
    }

    if (!in_wrapper) {
      // ` + typeof currentset === 'undefined'
      var allOptions =
        typeof currentset === "undefined"
          ? $(
              `<span class="checkbox-item"><input checked="checked"  type="checkbox" name="all-${key}" id="all-${key}"><label class="control-label checkbox-label" for="all-${key}">${localize.translations.flatSearchAll}</label></span>`,
            )
          : $(
              `<span class="checkbox-item"><input type="checkbox" name="all-${key}" id="all-${key}"><label class="control-label checkbox-label" for="all-${key}">${localize.translations.flatSearchAll}</label></span>`,
            );

      $(document).on("change", `#all-${key}`, () => {
        if ($(`#all-${key}`).prop("checked")) {
          $(`*[data-key="${key}"]`).each(function () {
            $(this).prop("checked", false);
          });

          delete $.lakaskereso.filters.utem;
          filterCb(undefined);
        }
      });

      innerWrapper.append(allOptions);
    }

    options.forEach((opt, i) => {
      var wrapper = $('<span class="checkbox-item"></span>');
      var tag = mapToSimpleTag(key + "-" + opt);
      var checkbox = $('<input type="checkbox"/>').attr({
        name: tag,
        id: tag,
        "data-key": key,
      });

      if (key == "lakopark") {
        const residential = $.lakaskereso.fulldb.lakopark.filter(
          (e) => e.nev === opt,
        );
        if (residential) {
          $(checkbox).attr("data-residential", residential[0]["id"]);
        }
      }
      if (key == "lakopark" && $(".t-residential").length) {
        if ($(".t-residential").data("project") != undefined) {
          var cpid = $.findObjectByKey(
            $.lakaskereso.fulldb.lakopark,
            "id",
            $(".t-residential").data("project").toString(),
          );

          if (cpid && opt == cpid.nev) {
            if (cpid.nev == "Sasad Resort") {
              if ($(".js-is-sasad-archive").length) {
                return;
              }
              cpid.nev = $.findObjectByKey(
                Object.values(localize.residentials),
                "id",
                $(".t-residential").data("id"),
              ).title;
            }
            $.lakaskereso.setFilter("lakopark", [cpid.nev]);
            currentset = currentFilterCb();
          }
        }
      }

      if (currentset && currentset.indexOf(opt) !== -1) {
        checkbox.prop("checked", true);
      }

      checkbox.change(() => {
        delete $.lakaskereso.filters.utem;
        var currentFilter = currentFilterCb();

        if (checkbox.prop("checked")) {
          //if the currentFilter is not undefined

          $(`#all-${key}`).prop("checked", false);

          if (currentFilter) {
            return filterCb(currentFilter.concat(opt));
          } else {
            return filterCb([opt]);
          }
        } else {
          if (!currentFilter) {
            currentFilter = [];
          }

          var removedList = currentFilter.filter((x) => x != opt);
          return filterCb(removedList.length > 0 ? removedList : undefined);
        }
      });
      wrapper.append(checkbox);

      var label = $('<label class="control-label checkbox-label"></label>')
        .text(typeof mapOptToLabel !== "undefined" ? mapOptToLabel(opt) : opt)
        .attr("for", tag);

      if ($.langCookie != "hu") {
        if (key == "kornyezet") {
          label = $('<label class="control-label checkbox-label"></label>')
            .text(
              typeof mapOptToLabel !== "undefined"
                ? mapOptToLabel(opt)
                : $.convertNeighbourhoodName(opt),
            )
            .attr("for", tag);
        }
        if (key == "kilatas") {
          label = $('<label class="control-label checkbox-label"></label>')
            .text(
              typeof mapOptToLabel !== "undefined"
                ? mapOptToLabel(opt)
                : $.convertViewName(opt),
            )
            .attr("for", tag);
        }

        if (key == "tajolas_web") {
          label = $('<label class="control-label checkbox-label"></label>')
            .text(
              typeof mapOptToLabel !== "undefined"
                ? mapOptToLabel(opt)
                : $.convertOrientation(opt),
            )
            .attr("for", tag);
        }
      }

      if (key == "kerulet") {
        var k = label.text();
        label.text(convertToRoman(k) + ". " + pestOrBuda(k));
      }

      if (key == "lakopark") {
        if (cordia_flat_db.lakopark[i].kulfold) {
          label.text(label.text());
        } else {
          label.text(
            label.text() + " " + pestOrBuda(cordia_flat_db.lakopark[i].kerulet),
          );
        }

        if ($(".t-residential").length) {
          outerWrapper.find(".dropdown__inner").show();
          outerWrapper.find(".dropdown__title").addClass("active");
        }
      }

      wrapper.append(label);
      innerWrapper.append(wrapper);

      if (in_wrapper) {
        $(outerWrapper).find(".dropdown__inner li").append(innerWrapper);
      } else {
        $(outerWrapper).append(innerWrapper);
      }
    });
  }

  function parseRangeMin(rangeMin, rangeMax, minValue, maxValue) {
    let currentMin = parseInt($(rangeMin).val());
    let currentMax = parseInt($(rangeMax).val());

    if (!currentMin || currentMin < minValue) {
      $(rangeMin).val(minValue);
      currentMin = minValue;
    }

    if (!currentMax || currentMax > maxValue) {
      $(rangeMax).val(maxValue);
      currentMax = maxValue;
    }

    if (currentMin > currentMax) {
      rangeMin.val($(rangeMax).val());
    }
  }

  function parseRangeMax(rangeMin, rangeMax, minValue, maxValue) {
    let currentMin = parseInt($(rangeMin).val());
    let currentMax = parseInt($(rangeMax).val());

    if (!currentMin || currentMin < minValue) {
      $(rangeMin).val(minValue);
      currentMin = minValue;
    }

    if (!currentMax || currentMax > maxValue) {
      $(rangeMax).val(maxValue);
      currentMax = maxValue;
    }

    if (currentMin > currentMax) {
      rangeMax.val($(rangeMin).val());
    }
  }

  $(".js-detailed-filters-clear").on("click", function (e) {
    e.preventDefault();
    $.lakaskereso.deleteFilters();
  });
  var init = true;

  $.lakaskereso = {
    //------------------------------------------
    // Kívülről megadható elemek
    //------------------------------------------
    //részletes keresőt "burkoló" dom element
    reszletesDomCol1: null,
    reszletesDomCol2: null,
    reszletesDomCol3: null,
    residentialDetails: null,
    //szobaslider
    szobarangeDom: null,
    //teruletslider
    teruletsliderDom: null,
    //lakasokdom
    lakasokDom: null,
    lakoparkokDom: null,
    //eredmény callback(projects,flats,teljes db)
    eredmenycb: null,
    //param change callback(filterparams)
    paramchangecb: null,
    selected: [],
    getSelected: function () {
      const selectedInLocalStorage = localStorage.getObj("selected") ?? [];

      if (!selectedInLocalStorage.length) {
        return;
      }

      const filetered = selectedInLocalStorage.filter((e) => {
        return this.fulldb.lakas.some((l) => {
          return l.id === e;
        });
      });

      localStorage.setObj("selected", filetered);

      this.selected = filetered;
    },
    showTechnicalDelivery: function () {
      if ($(".js-delivery-time-extra").length) {
        $(".js-delivery-time-extra").each(function () {
          const residentialId = $(this).data("residential");

          if (typeof residentialId === "undefined") {
            return;
          }

          const matchedItem = $.lakaskereso.fulldb.delivery.find(function (
            item,
          ) {
            return item.id === residentialId;
          });

          var technical_delivery_overwrite = null;
          if (localize.residentials[residentialId] != undefined) {
            technical_delivery_overwrite =
              localize.residentials[residentialId]
                .technical_delivery_overwrite;
          }

          if (technical_delivery_overwrite != null) {
            $(this).html(technical_delivery_overwrite);
          } else if (matchedItem && matchedItem.atadas) {
            $(this).html($.convertDeliveryName(matchedItem.atadas));
          } else {
            $(this).html("-");
          }
        });
      }

      if ($(".m-residential__card").length) {
        $(".m-residential__card").each(function () {
          const residentialId = $(this).data("residential");

          if (typeof residentialId === "undefined") {
            return;
          }

          var $delivery_in = $.lakaskereso.fulldb.delivery.filter(function (e) {
            return residentialId.toString().indexOf(e.lakopark_id) > -1;
          });

          const technicalDelivery = $(this).find(".js-technical-delivery");

          var id = $(this).data("id");
          const technicalDeliveryDetails = $(`#${id}`).find(
            ".js-technical-delivery",
          );
          var current_project = $.findObjectByKey(
            Object.values(localize.residentials),
            "id",
            id,
          );

          let deliveryDates = [];

          if ($delivery_in.length) {
            showData(technicalDelivery, "");
            showData(technicalDeliveryDetails, "");

            /* Sasad Resort custom order */

            let order = ["a024H00000iqAdoQAE", "a024H00000nGXg2QAG"]; //Sunrise, Panorama, Sungligh
            $delivery_in.sort((a, b) => {
              if (order.indexOf(a.id) === -1) return 1;
              if (order.indexOf(b.id) === -1) return -1;
              return order.indexOf(a.id) - order.indexOf(b.id);
            });

            $.each($delivery_in, function (i, e) {
              if (
                current_project &&
                current_project.show_only_this_residential_phase_technical_delivery ==
                  true &&
                e.id != current_project.sp_id
              ) {
                return;
              }

              if (
                localize.residentials[e.id] &&
                localize.residentials[e.id].hide_technical_delivery
              ) {
                return;
              }

              var technical_delivery_overwrite = null;
              if (localize.residentials[e.id] != undefined) {
                technical_delivery_overwrite =
                  localize.residentials[e.id].technical_delivery_overwrite;
              }

              var cut_string_from_technical_delivery = null;
              if (localize.residentials[e.id] != undefined) {
                cut_string_from_technical_delivery =
                  localize.residentials[e.id]
                    .cut_string_from_technical_delivery;
              }

              var hide_technical_delivery_prefix_text = false;
              if (localize.residentials[e.id] != undefined) {
                hide_technical_delivery_prefix_text =
                  localize.residentials[e.id]
                    .hide_technical_delivery_prefix_text;
              }

              var delivery_prefix = `${localize.translations.delivery}: `;

              var use_short_name_of_technical_delivery_prefix_text = false;
              if (localize.residentials[e.id] != undefined) {
                use_short_name_of_technical_delivery_prefix_text =
                  localize.residentials[e.id]
                    .use_short_name_of_technical_delivery_prefix_text;
              }

              if (use_short_name_of_technical_delivery_prefix_text) {
                delivery_prefix = `${localize.translations.delivery_short}: `;
              }

              var custom_technical_delivery_prefix_text = false;
              if (localize.residentials[e.id] != undefined) {
                custom_technical_delivery_prefix_text =
                  localize.residentials[e.id]
                    .custom_technical_delivery_prefix_text;
              }

              if (
                custom_technical_delivery_prefix_text &&
                custom_technical_delivery_prefix_text != ""
              ) {
                delivery_prefix = `${custom_technical_delivery_prefix_text}: `;
              }

              if (hide_technical_delivery_prefix_text) {
                delivery_prefix = "";
              }

              var name = e.nev_uj != undefined ? e.nev_uj : e.nev;

              if (cut_string_from_technical_delivery != null) {
                name = name
                  .replace(cut_string_from_technical_delivery, "")
                  .trim();
              }

              if (technical_delivery_overwrite != null) {
                deliveryDates.push({
                  [name]: delivery_prefix + technical_delivery_overwrite || "-",
                });
              } else {
                if (e.atadas != undefined) {
                  deliveryDates.push({
                    [name]:
                      delivery_prefix + $.convertDeliveryName(e.atadas) || "-",
                  });
                }
              }
            });

            if (deliveryDates.length) {
              if (deliveryDates.length === 1) {
                $(technicalDelivery).html(
                  `<img src="${localize.themeurl}/assets/img/svg/key.svg" alt="">` +
                    `<span>
                                  ${Object.values(deliveryDates[0])}</span>`,
                );
                $(technicalDeliveryDetails).html(
                  `<div class="wrapper"><img src="${localize.themeurl}/assets/img/svg/key-grey.svg" alt="">` +
                    `<span>
                                  ${Object.values(
                                    deliveryDates[0],
                                  )}</span></div>`,
                );
              }

              if (deliveryDates.length > 1) {
                deliveryDates.forEach((d, i) => {
                  var finalString = `${Object.keys(d)} ${Object.values(d)}`;
                  if (!finalString.includes("Sasad Resort Sunlight")) {
                    if (i > 0) {
                      $(technicalDelivery).append("<br>");
                    }

                    $(technicalDelivery).append(
                      `<img src="${localize.themeurl}/assets/img/svg/key.svg" alt="">` +
                        `<span>
                                            ${finalString.replace(
                                              /\s*:\s*/g,
                                              ": ",
                                            )}</span>`,
                    );
                    $(technicalDeliveryDetails).append(
                      `<div class="wrapper"><img src="${localize.themeurl}/assets/img/svg/key-grey.svg" alt="">` +
                        `<span>
                                            ${finalString.replace(
                                              /\s*:\s*/g,
                                              ": ",
                                            )}</span></div>`,
                    );
                  }
                });
              }
            }
          } else {
            showData(technicalDelivery, "");
            showData(technicalDeliveryDetails, "");
          }
        });

        if ($(window).width() > 991) {
          $(".residential__meta").matchHeight({ remove: true });
          $(".residential__meta-name").matchHeight({ remove: true });
          $(".residential-meta-desc").matchHeight({ remove: true });
          $(".residential__meta .js-technical-delivery").matchHeight({
            remove: true,
          });

          $(".residential__meta").matchHeight();
          $(".residential__meta-name").matchHeight();
          $(".residential-meta-desc").matchHeight();
          $(".residential__meta .js-technical-delivery").matchHeight();
        }
      }
    },
    //------------------------------------------
    // Belső állapotok és függvények
    //------------------------------------------
    favs: [],
    fulldb: {
      lakopark: [],
      project: [],
      lakas: [],
    },
    tablemap: [
      {
        by: "alaprajz",
        label: `<span class="abshow">${localize.translations.alaprajz}</span>`,
        mobilLabel: localize.translations.alaprajz,
        map: (e) => {
          let project = "";

          if (localize.residentials[e["project_id"]]) {
            project = e["project_id"]
              ? localize.residentials[e["project_id"]]["projekt_nev"]
              : "";
          }

          var flatimg =
            $(`<a class="js-image-preview flatgallery" data-fancybox="flat_${
              e["nev"]
            }" data-caption="${project} - ${e["nev"].replace(
              /^360M[-\s]?/,
              "",
            )}" href="${localize.imgurl}${e["id"].toLowerCase()}.jpg">
                            <img class="floor__plan_image skip-lazy" src="${
                              localize.imgurl
                            }${e["id"].toLowerCase()}.jpg">
                            
                                   </a>`);
          return flatimg;
        },
        sortable: false,
        tdClass: "td-preview",
      },
      {
        by: "info-col-1",
        label: "info-col-1",
        mobilLabel: "info-col-1",
        map: (e) => {
          let project = "";

          if (localize.residentials[e["project_id"]]) {
            project = e["project_id"]
              ? localize.residentials[e["project_id"]]["projekt_nev"]
              : "";
          }
          const floor =
            "<span>" +
            (e["emelet"] == 0
              ? localize.translations.groundFloor
              : e["emelet"] + ". " + localize.translations.floor) +
            "</span>";

          return $(
            "<span class='name'>" +
              project +
              "</span><span>" +
              e["szoba"] +
              " " +
              localize.translations.room +
              "</span>" +
              "<span>" +
              floor +
              "</span>",
          );
        },
        sortable: false,
        tdClass: "info-col-1",
      },
      {
        by: "info-col-2",
        label: "info-col-2",
        mobilLabel: "info-col-2",
        map: (e) => {
          var pid = e["project_id"];
          const flatCode = e["lakaskod"] != undefined ? e["lakaskod"] : e["nev"];
          const name = `<a class="name flat-url" target="_blank" href="${
            window.localize.residentials[pid] != undefined
              ? window.localize.residentials[pid].link
              : "#"
          }${flatCode}">${e["nev"].replace(/^360M[-\s]?/, "")}</a>`;
          const area =
            e["terulet_ossz"] +
            ` ${$.langCookie == "ru" ? " кв.м" : " m<sup>2</sup>"}`;
          const terrace =
            e["terulet_terasz"] == 0
              ? "-"
              : e["terulet_terasz"] +
                ` ${$.langCookie == "ru" ? " кв.м" : " m<sup>2</sup>"}`;
          const orientation =
            $.langCookie == "hu"
              ? e["tajolas_web"] ?? ""
              : $.convertOrientation(e["tajolas_web"] ?? "");

          return $(
            "<span>" +
              name +
              "</span>" +
              '<span class="area">' +
              area +
              "</span>" +
              '<span><span class="terrace__size">' +
              terrace +
              "</span><span class='terrace__label'>" +
              localize.translations.terrace.toLowerCase() +
              '</span></span><span class="orientation">' +
              orientation +
              "</span>",
          );
        },
        sortable: false,
        tdClass: "info-col-2",
      },
      {
        by: "info-mobile",
        label: "info-mobile",
        mobilLabel: "info-mobile",
        map: (e) => {
          let project = "";

          if (localize.residentials[e["project_id"]]) {
            project = e["project_id"]
              ? "<span class='name'>" +
                localize.residentials[e["project_id"]]["projekt_nev"] +
                "</span>"
              : "";
          }
          const name = `<span class="flat-name">${e["nev"].replace(
            /^360M[-\s]?/,
            "",
          )}</span>`;
          const area =
            "<span>" +
            e["terulet_ossz"] +
            ` ${$.langCookie == "ru" ? " кв.м" : " m<sup>2</sup>"}` +
            "</span>";
          const floor =
            "<span>" +
            (e["emelet"] == 0
              ? localize.translations.groundFloor
              : e["emelet"] + ". " + localize.translations.floor) +
            "</span>";
          const terrace =
            "<span class='terrace__name'>" +
            (e["terulet_terasz"] == 0
              ? "-"
              : '<span class="terrace__size">' + e["terulet_terasz"]) +
            ` ${$.langCookie == "ru" ? " кв.м" : " m<sup>2</sup>"}` +
            "</span><span class='terrace__label'>" +
            localize.translations.terrace.toLowerCase() +
            "</span></span>";
          const orientation =
            "<span>" + ($.langCookie == "hu")
              ? e["tajolas_web"] ?? ""
              : $.convertOrientation(e["tajolas_web"] ?? "") + "</span>";
          const room =
            "<span>" +
            e["szoba"] +
            " " +
            localize.translations.room +
            "</span>";
          const firtCol = `<span>${area}${terrace}${room}</span>`;
          const secondCol = `<span>${floor}${orientation}</span>`;

          return $(
            "<span class='info'>" +
              project +
              name +
              "</span>" +
              "<span class='details'>" +
              firtCol +
              secondCol +
              "</span>",
          );
        },
        sortable: false,
        tdClass: "info-mobile",
      },
      {
        by: "prefix",
        mobilLabel: "",
        map: (e) => {
          var div = $('<div class="toggle-wrapper"></div>');
          var wrapper = $(`<span class="checkbox-item"></span>`);

          var checkbox = $(
            `<input class="flatSelector" type="checkbox" name="${e["id"]}" id="${e["id"]}">`,
          ).change((i) => {
            $(checkbox)
              .parent()
              .parent()
              .parent()
              .parent()
              .toggleClass("selected");

            if (i.target.checked) {
              if ($.lakaskereso.selected.indexOf(e["id"]) === -1) {
                $.lakaskereso.selected.push(e["id"]);
              }
            } else {
              $.lakaskereso.selected = $.lakaskereso.selected.filter((elem) => {
                return elem != e["id"];
              });
            }

            localStorage.setObj("selected", $.lakaskereso.selected);

            $(".js-selected-flats").text(
              `${
                $.lakaskereso.selected.length > 0
                  ? "(" +
                    $.lakaskereso.selected.length +
                    " " +
                    $.pluralize(
                      localize.translations.flat,
                      $.lakaskereso.selected.length,
                    ) +
                    ")"
                  : ""
              }`,
            );
          });

          if ($.lakaskereso.selected.some((item) => item === e.id)) {
            checkbox.attr("checked", "checked");
          }

          var label = $(
            `<label class="control-label checkbox-label" for="${e["id"]}">${localize.translations.erdekel}</label>`,
          );
          wrapper.append([checkbox, label]);

          div.append(wrapper);

          if (typeof e["x3d_tura"] !== "undefined") {
            div.append(
              `<div class="tour3d-wrapper"><a class="tour3d-link js-tour-link" href="${e["x3d_tura"]}">${localize.translations.tour3d}</a></div>`,
            );
          }

          return div;
        },
        sortable: false,
        tdClass: "td-checkbox",
        thClass: "th-checkbox",
      },
    ],
    //queue update timeout
    updateTimeout: null,
    //fut-e refreshresult
    ongoingRefresh: false,
    //szűrt eredmény
    result: [],
    //szűrők
    filters: {},
    lakasok: [],
    //sorrendezés
    sort: {
      by: null,
      asc: true,
    },
    page: 1,
    //adatok betöltése
    initDb: function (parseParamsFromObj) {
      //grab all the params from url
      if (parseParamsFromObj) {
        try {
          var obj = parseParamsFromObj;

          if (obj["sort"] && obj["sort"]["by"]) {
            this.sort.by = obj["sort"]["by"];
          }
          if (obj["sort"] && typeof obj["sort"]["asc"] !== "undefined") {
            this.sort.asc = obj["sort"]["asc"];
          }

          if (obj["terulet"] && obj["terulet"].length == 2) {
            this.filters["terulet"] = obj["terulet"].map((e) => parseInt(e));
          }

          if (obj["buda"] != undefined) {
            this.filters["buda"] = obj["buda"];
          }
          if (obj["szoba"] && obj["szoba"].length == 2) {
            this.filters["szoba"] = obj["szoba"].map((e) => parseInt(e));
          }
          if (obj["kornyezet"] && obj["kornyezet"].length) {
            this.filters["kornyezet"] = obj["kornyezet"];
          }
          if (obj["kertkapcsolatos"] && obj["kertkapcsolatos"].length) {
            this.filters["kertkapcsolatos"] = obj["kertkapcsolatos"];
          }
          if (obj["kerulet"] && obj["kerulet"].length) {
            this.filters["kerulet"] = obj["kerulet"].map((e) => parseInt(e));
          }
          if (obj["lakopark"] && obj["lakopark"].length) {
            this.filters["lakopark"] = obj["lakopark"];
          }
          if (obj["emelet"] && obj["emelet"].length) {
            this.filters["emelet"] = obj["emelet"].map((e) => parseInt(e));
          }
          if (obj["terasz"] && obj["terasz"].length == 2) {
            this.filters["terasz"] = obj["terasz"].map((e) => parseInt(e));
          }
          if (obj["tajolas_web"] && obj["tajolas_web"].length) {
            this.filters["tajolas_web"] = obj["tajolas_web"];
          }

          if (obj["energiatakarekos"] && obj["energiatakarekos"].length) {
            this.filters["energiatakarekos"] = obj["energiatakarekos"];
            $("#energy").prop("checked", true);
          }
          if (obj["kedvezmenyes"] && obj["kedvezmenyes"].length) {
            this.filters["kedvezmenyes"] = obj["kedvezmenyes"];
            $("#discounted").prop("checked", true);
            $("#discounted2").prop("checked", true);
          }

          if (obj["azonnal_koltozheto"] && obj["azonnal_koltozheto"].length) {
            this.filters["azonnal_koltozheto"] = obj["azonnal_koltozheto"];
            $("#immediet_pos").prop("checked", true);
          }

          if (obj["kilatas"] && obj["kilatas"].length) {
            this.filters["kilatas"] = obj["kilatas"];
          }

          if (obj["pg"]) {
            this.page = obj["pg"];
          }
        } catch (e) {
          console.log("Error in parse", e);
        }
      }

      $.loadFlatDB((res) => {
        this.fulldb = res;

        //modify data in flats
        this.fulldb.lakas = this.fulldb.lakas.map((flat) => {
          flat["terulet_kert"] =
            typeof flat["terulet_kert"] == "undefined"
              ? 0
              : parseFloat(flat["terulet_kert"]);
          flat["terulet_ossz"] =
            typeof flat["terulet_ossz"] == "undefined"
              ? 0
              : parseFloat(flat["terulet_ossz"]);
          flat["terulet_terasz"] =
            typeof flat["terulet_terasz"] == "undefined"
              ? 0
              : parseFloat(flat["terulet_terasz"]);
          flat["emelet"] =
            typeof flat["emelet"] == "undefined" ? 0 : parseInt(flat["emelet"]);
          return flat;
        });

        this.fulldb.project = this.fulldb.project.map((proj) => {
          if (typeof proj["kerulet"] != "undefined") {
            proj["kerulet"] = parseFloat(proj["kerulet"]);
          }
          return proj;
        });

        this.getSelected();

        if ($(".t-map-search").length) {
          $(
            this.fulldb.project
              .map((e) => e["kerulet"])
              .filter((e) => e)
              .filter($.onlyUnique)
              .map((e) => parseInt(e))
              .sort((a, b) => a - b),
          ).each(function (i, e) {
            if ($.searchMap != null) {
              $.search_add_layers(e, $.searchMap);
            }
          });
        }

        if ($(".m-residential__card").length) {
          this.showTechnicalDelivery();
        }

        if ($(".js-delivery-time-extra").length) {
          this.showTechnicalDelivery();
        }

        if (this.fulldb.lakopark.length) {
          this.refreshResult();
        }
      });
    },
    //filterezés
    doFiltering: function () {
      this.result = this.fulldb["lakas"].filter((lakas) => {
        //csak negativ filtereket használunk

        //szoba szuro, szoba biztosan van!
        if (typeof this.filters["szoba"] !== "undefined") {
          if (lakas["szoba"] < this.filters["szoba"][0]) {
            return false;
          }
          if (lakas["szoba"] > this.filters["szoba"][1]) {
            return false;
          }
        }

        //terulet szuro, terulet biztosan van!
        if (typeof this.filters["terulet"] !== "undefined") {
          if (lakas["terulet_ossz"] < this.filters["terulet"][0]) {
            return false;
          }
          if (lakas["terulet_ossz"] > this.filters["terulet"][1]) {
            return false;
          }
        }

        //buda szuro
        if (typeof this.filters["buda"] !== "undefined") {
          var theproject = this.fulldb.project.filter(
            (p) => p.id == lakas["project_id"],
          );
          if (theproject.length == 1) {
            if (theproject[0]["buda"] != this.filters["buda"]) {
              return false;
            }
          }
        }

        //kornyezet szuro (opcionalis a kornyezet a projecteken!!)
        if (typeof this.filters["kornyezet"] !== "undefined") {
          var theproject = this.fulldb.project.filter(
            (p) => p.id == lakas["project_id"],
          );

          if (theproject.length == 1) {
            //ha nincs kornyezet projekten, de van kornyezet szuro, instant kihullik

            if (!theproject[0]["kornyezet"]) {
              return false;
            }
            if (
              this.filters["kornyezet"].indexOf(theproject[0]["kornyezet"]) ==
              -1
            ) {
              return false;
            }
          }
        }

        //kertkapcsolatos
        if (typeof this.filters["kertkapcsolatos"] !== "undefined") {
          if (
            !lakas["terulet_kert"] &&
            this.filters["kertkapcsolatos"][0] === "Kertkapocsolatos"
          ) {
            return false;
          }

          if (
            lakas["terulet_kert"] &&
            this.filters["kertkapcsolatos"][0] === "NemKertkapocsolatos"
          ) {
            return false;
          }
        }

        //kerulet szuro
        if (typeof this.filters["kerulet"] !== "undefined") {
          var theproject = this.fulldb.project.filter(
            (p) => p.id == lakas["project_id"],
          );
          if (theproject.length == 1) {
            //ha nincs kerulet projekten, de van kerulet szuro, instant kihullik
            if (!theproject[0]["kerulet"]) {
              return false;
            }
            if (
              this.filters["kerulet"].indexOf(theproject[0]["kerulet"]) == -1
            ) {
              return false;
            }
          }
        }

        //lakopark szuro
        if (typeof this.filters["lakopark"] !== "undefined") {
          var theproject = this.fulldb.project.filter(
            (p) => p.id == lakas["project_id"],
          );
          if (theproject.length == 1) {
            var thelakopark = this.fulldb.lakopark.filter(
              (p) => p.id == theproject[0]["lakopark_id"],
            );
            //ha nincs kerulet projekten, de van kerulet szuro, instant kihullik
            if (thelakopark.length == 1) {
              if (!thelakopark[0]["nev"]) {
                return false;
              }
              if (
                this.filters["lakopark"].indexOf(thelakopark[0]["nev"]) == -1
              ) {
                return false;
              }
            }
          }
        }

        //emelet szuro
        if (typeof this.filters["emelet"] !== "undefined") {
          if (typeof lakas["emelet"] === "undefined") {
            return false;
          }

          if (this.filters["emelet"].indexOf(lakas["emelet"]) == -1) {
            return false;
          }
        }

        //terasz szuro
        if (typeof this.filters["terasz"] !== "undefined") {
          if (lakas["terulet_terasz"] < this.filters["terasz"][0]) {
            return false;
          }
          if (lakas["terulet_terasz"] > this.filters["terasz"][1]) {
            return false;
          }
        }

        if (typeof this.filters["tajolas_web"] !== "undefined") {
          if (
            typeof lakas["tajolas_web"] === "undefined" ||
            !lakas["tajolas_web"].length
          ) {
            return false;
          }

          const flatOrientation = lakas["tajolas_web"].split(";");

          let valid = true;

          this.filters["tajolas_web"].forEach((or) => {
            if (flatOrientation.indexOf(or) == -1) {
              valid = false;
            }
          });

          if (!valid) {
            return false;
          }
        }

        if (typeof this.filters["energiatakarekos"] !== "undefined") {
          if (typeof lakas["energiatakarekos"] === "undefined") {
            return false;
          }

          if (lakas["energiatakarekos"] != 1) {
            return false;
          }
        }

        if (typeof this.filters["kedvezmenyes"] !== "undefined") {
          if (typeof lakas["kedvezmenyes"] === "undefined") {
            return false;
          }

          if (lakas["kedvezmenyes"] != 1) {
            return false;
          }
        }

        if (typeof this.filters["azonnal_koltozheto"] !== "undefined") {
          if (typeof lakas["azonnal_koltozheto"] === "undefined") {
            return false;
          }

          if (lakas["azonnal_koltozheto"] != 1) {
            return false;
          }
        }

        if (typeof this.filters["kilatas"] !== "undefined") {
          if (typeof lakas["kilatas_web"] === "undefined") {
            return false;
          }

          const view = lakas["kilatas_web"].split(";");
          let valid = false;

          this.filters["kilatas"].forEach((v) => {
            if (view.indexOf(v) !== -1) {
              valid = true;
              return;
            }
          });

          if (!valid) {
            return false;
          }
        }

        return true;
      });

      this.result = this.result.sort((a, b) => {
        const sortKey = this.sort.by || "nev";

        if (sortKey === "nev") {
          const parseParts = (str) =>
            str
              .split(/[\.\-\s\(\)]+/)
              .map((part) =>
                /^\d+$/.test(part) ? parseInt(part, 10) : part.toLowerCase(),
              );

          const partsA = parseParts(a[sortKey]);
          const partsB = parseParts(b[sortKey]);

          for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
            const partA = partsA[i];
            const partB = partsB[i];

            if (partA === undefined) return this.sort.asc ? -1 : 1;
            if (partB === undefined) return this.sort.asc ? 1 : -1;

            if (partA !== partB) {
              if (typeof partA === "number" && typeof partB === "number") {
                return this.sort.asc ? partA - partB : partB - partA;
              }
              // Fix: Ensure both are strings before calling localeCompare
              return this.sort.asc
                ? String(partA).localeCompare(String(partB))
                : String(partB).localeCompare(String(partA));
            }
          }
          return 0;
        }

        // Original lexicographic fallback for other fields
        if (a[sortKey] < b[sortKey]) return this.sort.asc ? 1 : -1;
        if (a[sortKey] > b[sortKey]) return this.sort.asc ? -1 : 1;

        return 0;
      });
    },

    refreshFilterList: function () {
      const filters = this.filters;
      let filterString = "";

      if (filters.kerulet) {
        filterString +=
          filters.kerulet
            .sort((a, b) => a - b)
            .toString()
            .replaceAll(/,/g, "-") +
          ". " +
          localize.translations.keruletben +
          ", ";
      }

      if (filters.lakopark) {
        let currentResidenttials = [];
        currentResidenttials = [...filters.lakopark];
        const residentialLinks = [];

        currentResidenttials.forEach((e, index) => {
          const lakopark_id = $.lakaskereso.fulldb.lakopark.filter(
            (project) => {
              return project.nev == e;
            },
          );

          if (!lakopark_id.length) {
            residentialLinks.push(e);
            return;
          }

          const project_id = $.lakaskereso.fulldb.project.filter((project) => {
            return project.lakopark_id == lakopark_id[0].id;
          });

          if (!project_id.length) {
            residentialLinks.push(e);
            return;
          }

          const project_link = localize.residentials[project_id[0].id]?.link;

          if (!project_link) {
            residentialLinks.push(e);
            return;
          }

          residentialLinks.push(
            `<a class="active-filter--link" target="_blank" href="${project_link}">${e}</a>`,
          );
        });

        filterString += residentialLinks.toString() + ", ";
      }

      if (filters.szoba) {
        filterString +=
          filters.szoba.toString().replaceAll(/,/g, "-") +
          " " +
          localize.translations.szobas +
          ", ";
      }

      if (filters.terulet) {
        filterString +=
          filters.terulet.toString().replaceAll(/,/g, "-") + " \u33A1" + ", ";
      }

      if (filters.emelet) {
        if (filters.emelet.includes(0)) {
          filterString += localize.translations.groundFloor + ", ";
        }

        filterString +=
          filters.emelet
            .filter((e) => e != 0)
            .sort((a, b) => a - b)
            .toString()
            .replaceAll(/,/g, "-") +
          ". " +
          localize.translations.floor +
          ", ";
      }

      if (filters.kertkapcsolatos) {
        filterString +=
          filters.kertkapcsolatos[0] === "Kertkapocsolatos"
            ? localize.translations.yard + ", "
            : localize.translations.noyard + ", ";
      }

      if (filters.kornyezet) {
        filterString +=
          $.convertNeighbourhoodName(
            filters.kornyezet.toString().replaceAll(/,/g, "-"),
          ) +
          " " +
          localize.translations.kornyezet +
          ", ";
      }

      if (filters.energiatakarekos) {
        filterString += localize.translations.energyefficient + ", ";
      }

      if (filters.kedvezmenyes) {
        filterString += localize.translations.discounted + ", ";
      }

      if (filters.azonnal_koltozheto) {
        filterString += localize.translations.immediet_pos + ", ";
      }

      if (filters.kilatas) {
        filterString +=
          localize.translations.kilatas +
          ": " +
          $.convertViewName(filters.kilatas.toString().replaceAll(/,/g, "-")) +
          ", ";
      }

      if (filters.tajolas_web) {
        filterString +=
          localize.translations.tajolas +
          ": " +
          $.convertOrientation(
            filters.tajolas_web.toString().replaceAll(/,/g, "-"),
          ) +
          ", ";
      }

      filterString = filterString.replace(/(^,)|(,$)|(, $)|/g, "");

      $(".js-active-filters").html(filterString);
    },

    setSort: function (by, asc) {
      if (this.sort.by != by || this.sort.asc != asc) {
        this.sort = {
          by: by,
          asc: asc,
        };

        if (this.paramchangecb) {
          var p = Object.assign(
            {
              sort: this.sort,
            },
            this.filters,
          );
          this.paramchangecb(p);
        }
        this.queueUpdate();
      }
    },
    setPage: function (page) {
      if (this.page != page) {
        this.page = page;
      }

      if (this.paramchangecb) {
        var p = Object.assign(
          {
            page: this.page,
          },
          this.filters,
        );
        this.paramchangecb(p);
      }
      this.queueUpdate();
    },
    setFilter: function (name, values) {
      if (
        typeof values === "undefined" &&
        typeof this.filters[name] !== "undefined"
      ) {
        delete this.filters[name];
        if (this.paramchangecb) {
          var p = Object.assign(
            {
              sort: this.sort,
            },
            this.filters,
          );
          this.paramchangecb(p);
        }
        this.queueUpdate();
        return;
      }

      if (
        typeof this.filters[name] !== "undefined" &&
        JSON.stringify(this.filters[name]) == JSON.stringify(values)
      ) {
        //already set
        return;
      }

      this.filters[name] = values;

      if (this.paramchangecb) {
        var p = Object.assign(
          {
            sort: this.sort,
          },
          this.filters,
        );
        this.paramchangecb(p);
      }

      this.queueUpdate();
    },
    deleteFilters: function () {
      this.filters = {};
      this.selected = [];
      localStorage.setObj("selected", $.lakaskereso.selected);

      $(".js-selected-flats").text(
        `${
          $.lakaskereso.selected.length > 0
            ? "(" + $.lakaskereso.selected.length + ")"
            : ""
        } `,
      );

      $("#district__filter")
        .find("input")
        .each(function () {
          $(this).prop("checked", false).change();
        });

      $("#residential-filter")
        .find("input")
        .each(function () {
          $(this).prop("checked", false).change();
        });

      $("#detailed-filters-col1")
        .find(".dropdown--light")
        .find("input")
        .each(function () {
          $(this).prop("checked", false).change();
        });

      $("#both-kertkapcsolatos").prop("checked", true).change();
      $("#all-kilatas").prop("checked", true).change();

      $("#all-kornyezet").prop("checked", true).change();
      $("#all-tajolas_web").prop("checked", true).change();

      $("#energy").prop("checked", false).change();

      $("#discounted").prop("checked", false).change();
      $("#discounted2").prop("checked", false).change();

      $("#immediet_pos").prop("checked", false).change();

      $.urlParams = null;
      if ($(".t-flats-search").length) {
        window.history.replaceState({}, null, window.location.pathname);
      }

      $("#both-city").attr("checked", true);
      this.queueUpdate();
    },
    //update "idözitése"
    queueUpdate() {
      clearTimeout(this.updateTimeout);
      var theTimeout = () => {
        if (this.ongoingRefresh) {
          this.updateTimeout = setTimeout(theTimeout, 100);
          return;
        }

        this.refreshResult();
      };
      this.updateTimeout = setTimeout(theTimeout, 42);
    },
    //szoba slider frissítése
    updateDomRoomNumRange: function () {
      if (!this.szobarangeDom) {
        return;
      }

      var szobak = this.fulldb.lakas
        .map((l) => parseInt(l.szoba))
        .filter((szoba) => !isNaN(szoba));
      var minRoom = Math.min(...szobak);
      var maxRoom = Math.max(...szobak);

      var $current_range_parent = $(this.szobarangeDom);
      var rangeMin = $current_range_parent.find($(".js-range-min"));
      var rangeMax = $current_range_parent.find($(".js-range-max"));

      rangeMin.attr({
        placeholder: minRoom,
      });

      rangeMax.attr({
        placeholder: maxRoom,
      });

      if (this.filters["szoba"]) {
        rangeMin.val(this.filters["szoba"][0]);
        rangeMax.val(this.filters["szoba"][1]);
      }

      $(rangeMin).on("change", () => {
        parseRangeMin(rangeMin, rangeMax, minRoom, maxRoom);
        delete $.lakaskereso.filters.utem;
        this.setFilter("szoba", [
          parseInt(rangeMin.val()),
          parseInt(rangeMax.val()),
        ]);
      });

      $(rangeMax).on("change", () => {
        parseRangeMax(rangeMin, rangeMax, minRoom, maxRoom);
        delete $.lakaskereso.filters.utem;
        this.setFilter("szoba", [
          parseInt(rangeMin.val()),
          parseInt(rangeMax.val()),
        ]);
      });
    },

    //terület slider frissítése
    updateDomTeruletslider: function () {
      if (!this.teruletsliderDom) {
        return;
      }

      var terulet = this.fulldb.lakas
        .map((l) => parseFloat(l.terulet_ossz))
        .filter((terulet) => !isNaN(terulet));
      var minTerulet = Math.ceil(Math.min(...terulet));
      var maxTerulet = Math.floor(Math.max(...terulet));
      var $current_range_parent = $(this.teruletsliderDom);
      var rangeMin = $current_range_parent.find($(".js-range-min"));
      var rangeMax = $current_range_parent.find($(".js-range-max"));

      rangeMin.attr({
        min: minTerulet,
        max: maxTerulet,
        placeholder: minTerulet,
      });

      rangeMax.attr({
        min: minTerulet,
        max: maxTerulet,
        placeholder: maxTerulet,
      });

      if (this.filters["terulet"]) {
        rangeMin.val(this.filters["terulet"][0]);
        rangeMax.val(this.filters["terulet"][1]);
      }

      $(rangeMin).on("change", () => {
        parseRangeMin(rangeMin, rangeMax, minTerulet, maxTerulet);
        delete $.lakaskereso.filters.utem;
        this.setFilter("terulet", [
          parseInt(rangeMin.val()),
          parseInt(rangeMax.val()),
        ]);
      });

      $(rangeMax).on("change", () => {
        parseRangeMax(rangeMin, rangeMax, minTerulet, maxTerulet);
        delete $.lakaskereso.filters.utem;
        this.setFilter("terulet", [
          parseInt(rangeMin.val()),
          parseInt(rangeMax.val()),
        ]);
      });
    },
    updateDetails: function () {
      if (!this.residentialDetails) {
        return;
      }

      if (!this.residentialDetails["jquery"]) {
        this.residentialDetails = $(this.residentialDetails);
        var residentialDetails = this.residentialDetails;
        residentialDetails.html("");

        if (
          $.lakaskereso.filters.utem &&
          window.localize.residentials[$.lakaskereso.filters.utem] != undefined
        ) {
          if (
            window.localize.residentials[$.lakaskereso.filters.utem]
              .featured_image != undefined
          ) {
            $("#residential-img").show();
            $("#residential-img").css(
              "background-image",
              `url(${
                window.localize.residentials[$.lakaskereso.filters.utem]
                  .featured_image
              })`,
            );
          }

          if (
            window.localize.residentials[$.lakaskereso.filters.utem].location
              .address != undefined
          ) {
            $(".location-link").show();
            $(".location-link").attr(
              "href",
              `https://www.google.com/maps?q=${
                window.localize.residentials[$.lakaskereso.filters.utem]
                  .location.address
              }`,
            );
          }
          if (
            (window.localize.residentials[$.lakaskereso.filters.utem]
              .hide_technical_delivery == true ||
              $.convertDeliveryName(
                $.findObjectByKey(
                  $.lakaskereso.fulldb.delivery,
                  "id",
                  $.lakaskereso.filters.utem.toString(),
                ).atadas,
              ) == "-") &&
            window.localize.residentials[$.lakaskereso.filters.utem]
              .technical_delivery_overwrite == null
          ) {
            $(".technical-delivery").hide();
          } else {
            if (
              window.localize.residentials[$.lakaskereso.filters.utem]
                .technical_delivery_overwrite != null
            ) {
              $("p.technical-delivery__inner").hide();
              $(".js-search-technical-delivery").text(
                `${
                  window.localize.residentials[$.lakaskereso.filters.utem]
                    .technical_delivery_overwrite
                }`,
              );
            } else {
              $("p.technical-delivery__inner").show();
              $(".js-search-technical-delivery").text(
                `${$.convertDeliveryName(
                  $.findObjectByKey(
                    $.lakaskereso.fulldb.delivery,
                    "id",
                    $.lakaskereso.filters.utem.toString(),
                  ).atadas,
                )}`,
              );
            }

            $(".technical-delivery").show();
          }
        } else {
          $("#residential-img").hide();
          $(".location-link").hide();
          $(".js-search-technical-delivery").hide();
        }

        /* Load state of view */
        if (localStorage.getObj("listview") != null) {
          var isListView = localStorage.getObj("listview");
          if (isListView) {
            $(".js-clone-to").addClass("col-xl-12 col-xxl-12 fullwidth");
            $(".t-map-search").hide();
            $("#js-list-view").addClass("active");
            $("#js-map-view").removeClass("active");
          } else {
            $(".js-clone-to").removeClass("col-xl-12 col-xxl-12 fullwidth");
            $(".t-map-search").show();
            $("#js-map-view").addClass("active");
            $("#js-list-view").removeClass("active");
          }
        }

        $(".js-fullscreen-loader").fadeOut(200, function () {
          $("main").removeClass("fullheight");
          $(".js-filter-tab").fadeIn(200);
        });
      } else {
        if (
          $.lakaskereso.filters.utem &&
          window.localize.residentials[$.lakaskereso.filters.utem] != undefined
        ) {
          if (
            window.localize.residentials[$.lakaskereso.filters.utem]
              .featured_image != undefined
          ) {
            $("#residential-img").show();
            $("#residential-img").css(
              "background-image",
              `url(${
                window.localize.residentials[$.lakaskereso.filters.utem]
                  .featured_image
              })`,
            );
          }

          if (
            window.localize.residentials[$.lakaskereso.filters.utem].location
              .address != undefined
          ) {
            $(".location-link").show();
            $(".location-link").attr(
              "href",
              `https://www.google.com/maps?q=${
                window.localize.residentials[$.lakaskereso.filters.utem]
                  .location.address
              }`,
            );
          }

          if (
            (window.localize.residentials[$.lakaskereso.filters.utem]
              .hide_technical_delivery == true ||
              $.convertDeliveryName(
                $.findObjectByKey(
                  $.lakaskereso.fulldb.delivery,
                  "id",
                  $.lakaskereso.filters.utem.toString(),
                ).atadas,
              ) == "-") &&
            window.localize.residentials[$.lakaskereso.filters.utem]
              .technical_delivery_overwrite == null
          ) {
            $(".technical-delivery").hide();
          } else {
            if (
              window.localize.residentials[$.lakaskereso.filters.utem]
                .technical_delivery_overwrite != null
            ) {
              $("p.technical-delivery__inner").hide();
              $(".js-search-technical-delivery").text(
                `${
                  window.localize.residentials[$.lakaskereso.filters.utem]
                    .technical_delivery_overwrite
                }`,
              );
            } else {
              $("p.technical-delivery__inner").show();
              $(".js-search-technical-delivery").text(
                `${$.convertDeliveryName(
                  $.findObjectByKey(
                    $.lakaskereso.fulldb.delivery,
                    "id",
                    $.lakaskereso.filters.utem.toString(),
                  ).atadas,
                )}`,
              );
            }
            $(".technical-delivery").show();
          }
        } else {
          $("#residential-img").hide();
          $(".location-link").hide();
          $(".js-search-technical-delivery").hide();
        }
      }
    },
    updateDomResidentials: function () {
      if (!this.lakoparkokDom) {
        return;
      }

      this.lakoparkokDom = $(this.lakoparkokDom);

      var counts = jQuery.lakaskereso.result.reduce((p, c) => {
        var name = c.project_id;
        if (!p.hasOwnProperty(name)) {
          p[name] = 0;
        }
        p[name]++;
        return p;
      }, {});

      var selected = [];
      var highlighted_projects = [
        "a025800000GRxUfAAL",
        "a025800000PF1KLAA1",
        "a025800000LggOhAAJ",
      ];

      counts = Object.keys(counts)
        .sort(function (a, b) {
          return counts[b] - counts[a];
        })
        .filter(function (item) {
          var includes = highlighted_projects.includes(item);
          if (includes) {
            selected.push(item);
          }
          return !includes;
        });

      selected = selected.sort(function (a, b) {
        return highlighted_projects.indexOf(a) < highlighted_projects.indexOf(b)
          ? -1
          : 1;
      });

      counts = [...selected, ...counts];

      var residential = counts
        .map((e) => {
          var lehetProject = $.lakaskereso.fulldb.project.filter(
            (p) => p.id == e,
          );
          return lehetProject.length == 0 ? null : lehetProject[0];
        })
        .filter($.onlyUnique);

      if (residential.length > 0) {
        if (
          $("#residential-details,#residential-tabs").css("display") == "none"
        ) {
          $("#residential-details,#residential-tabs").slideDown();
        }
        $.lakaskereso.filters.utem = residential[0].id;
      } else {
        delete $.lakaskereso.filters["utem"];
        $(".js-number-of-flats").text(
          `0 ${$.pluralize(localize.translations.freeflats, 0)}`,
        );
        $("#residential-details,#residential-tabs").slideUp();
      }
    },
    updateDomFlatlist: function () {
      if (!this.lakasokDom) {
        return;
      }

      const page = $.getPage(window.location.search);
      const flatPerPage = 16;
      const pageCount = Math.ceil(this.result.length / flatPerPage);

      this.lakasok = this.result
        .sort(compareFlatsByProjectOrder)
        .filter(
          (el, ind) =>
            ind < flatPerPage * page && ind >= (page - 1) * flatPerPage,
        );

      if ($(window).width() < 576) {
        getMobilePagination(pageCount, page);
      } else {
        getPaginationNumbers(pageCount, page);
      }
      setCurrentPage(page, pageCount, flatPerPage);

      //this is the first time we are here
      if (!this.lakasokDom["jquery"]) {
        this.lakasokDom = $(this.lakasokDom);
        this.lakasokDom.html("");

        //create table
        var table = $(
          "<div class='table table-mc-border table-hover display no-wrap table table-greyhead table__offers js-table-offers' style='width: 100%;'></div>",
        );
        var thead = $("<div class='thead'></div>");
        var tbody = $("<div class='tbody'></div>");

        table.append(thead);
        table.append(tbody);
        this.lakasokDom.append(table);
      }

      //regular update
      var heads = this.lakasokDom.find("thead th");
      heads.each((i, item) => {
        if ($(item).data("by") != this.sort.by) {
          $(item).removeClass("sorting_asc").removeClass("sorting_desc");
        } else {
          if (this.sort.asc) {
            $(item).removeClass("sorting_asc").addClass("sorting_desc");
          } else {
            $(item).removeClass("sorting_desc").addClass("sorting_asc");
          }
        }
      });
      var tbody = this.lakasokDom.find(".tbody");
      var lines = tbody.find(".tr");

      //remove extra lines
      if (this.lakasok.length < lines.length) {
        lines.each((i, line) => {
          if (i >= this.lakasok.length) {
            $(line).remove();
          }
        });
      }

      //update each line
      for (var i = 0; i < this.lakasok.length; i++) {
        var theline = null;
        if (lines.length < i + 1) {
          theline = $("<div class='tr table__offers js-table-offer'></div>");

          for (var j = 0; j < this.tablemap.length; j++) {
            var tdClass = this.tablemap[j].tdClass;

            var thecol = $(
              `<div class="column" data-title="${this.tablemap[j].mobilLabel}"></div>`,
            );
            if (tdClass != undefined) {
              thecol.addClass(tdClass);
            }
            theline.append(thecol);
          }
          tbody.append(theline);
        } else {
          theline = $(lines[i]);
        }

        //we have the line, now only update it
        var cells = theline.find("div");

        for (var k = 0; k < this.tablemap.length; k++) {
          var newdata = this.tablemap[k].map(this.lakasok[i]);
          var tdClass = this.tablemap[k].tdClass;
          var thecol = $(
            `<div data-title="${this.tablemap[k].mobilLabel}"></div>`,
          );
          if (tdClass != undefined) {
            thecol.addClass(tdClass);
          }
          if (typeof newdata == "string") {
            $(cells[k]).text(newdata);
          } else {
            const checkboxItem = $(newdata).hasClass("checkbox-item")
              ? $(checkboxItem)
              : false;
            if (checkboxItem) {
              if ($(checkboxItem).find(".flatSelector").prop("checked")) {
                $(theline).addClass("selected");
              } else {
                $(theline).removeClass("selected");
              }
            }

            $(cells[k]).replaceWith(thecol.append(newdata));
          }
        }
      }
    },
    updateDomReszletes: function () {
      if (
        !this.reszletesDomCol1 ||
        !this.reszletesDomCol2 ||
        !this.reszletesDomCol3
      ) {
        return;
      }

      if (!this.reszletesDomCol1["jquery"]) {
        this.reszletesDomCol1 = $(this.reszletesDomCol1);
        this.reszletesDomCol1.html("");
        //kerulet
        keresoAddCheckboxes(
          this.districtFilter,
          () => this.filters["kerulet"],
          (keruletFilter) => this.setFilter("kerulet", keruletFilter),
          this.fulldb.project
            .map((e) => e["kerulet"])
            .filter((e) => e)
            .filter($.onlyUnique)
            .map((e) => parseInt(e))
            .sort((a, b) => a - b),
          localize.translations.district,
          "kerulet",
        );

        //lakopark
        keresoAddCheckboxes(
          this.residentialFilter,
          () => this.filters["lakopark"],
          (lakoparkFilter) => this.setFilter("lakopark", lakoparkFilter),
          this.fulldb.lakopark
            .map((e) => e["nev"])
            .filter((e) => e)
            .filter($.onlyUnique),
          localize.translations.residentialPark,
          "lakopark",
        );

        //emelet
        keresoAddCheckboxes(
          this.reszletesDomCol1,
          () => this.filters["emelet"],
          (emelet) => this.setFilter("emelet", emelet),
          this.fulldb.lakas
            .map((e) => e["emelet"])
            .filter($.onlyUnique)
            .sort((a, b) => a - b),
          localize.translations.floor,
          "emelet",
          (emeletSzam) =>
            emeletSzam === 0
              ? localize.translations.groundFloor
              : emeletSzam + ". " + localize.translations.floor,
        );

        if ($("[data-showflatlist]").data("showflatlist") != true) {
          //Kertkapcsolatos
          keresoAddKert(
            this.reszletesDomCol1,
            () => {
              if (typeof this.filters["kertkapcsolatos"] !== "undefined") {
                if (this.filters["kertkapcsolatos"][0] === "Kertkapocsolatos") {
                  return true;
                }

                if (
                  this.filters["kertkapcsolatos"][0] === "NemKertkapocsolatos"
                ) {
                  return false;
                }
              }
            },

            (kertkapcsolatosFilter) => {
              if (typeof kertkapcsolatosFilter === "undefined") {
                this.setFilter("kertkapcsolatos", undefined);
                return;
              }

              if (kertkapcsolatosFilter === true) {
                this.setFilter("kertkapcsolatos", ["Kertkapocsolatos"]);
                return;
              }

              if (kertkapcsolatosFilter === false) {
                this.setFilter("kertkapcsolatos", ["NemKertkapocsolatos"]);
              }
            },
          );

          $.lakaskereso.reszletesDomCol1.append(`<div class="checkbox-group"
                    <span class="checkbox-item">
                    <input type="checkbox" name="discounted" id="discounted2">
                    <label class="control-label control-label--bold checkbox-label checkbox-label--orange" for="discounted2">
                    ${localize.translations.discounted_flats}
                    </label></span></div>`);

          if (
            $.lakaskereso.filters.kedvezmenyes != undefined &&
            $.lakaskereso.filters.kedvezmenyes == true
          ) {
            $("#discounted2").prop("checked", true);
          }
        }

        if ($(".t-residential").length) {
          if ($(".t-residential").data("project") != undefined) {
            var $residential_in = $.findObjectByKey(
              $.lakaskereso.fulldb.lakopark,
              "id",
              $(".t-residential").data("project").toString(),
            );

            if ($residential_in != null) {
              $(".js-search-widget").show();
              $(".js-ask-offers").show();
            }

            var $delivery_in = $.lakaskereso.fulldb.delivery.filter(function (
              e,
            ) {
              return (
                jQuery(".t-residential")
                  .data("project")
                  .toString()
                  .indexOf(e.lakopark_id) > -1
              );
            });

            if ($delivery_in.length) {
              const hasLegacyResidentialDatas =
                $(".residential__datas_wrapper").length > 0;
              const technicalDeliverySelector = hasLegacyResidentialDatas
                ? ".residential__datas_wrapper .js-technical-delivery"
                : ".js-technical-delivery";

              showData(technicalDeliverySelector, "");

              /* Sasad Resort custom order */

              let order = [
                "a024H00000nI4j4QAC",
                "a024H00000iqAdoQAE",
                "a024H00000nGXg2QAG",
              ]; //Sunrise, Panorama, Sungligh
              $delivery_in.sort((a, b) => {
                if (order.indexOf(a.id) === -1) return 1;
                if (order.indexOf(b.id) === -1) return -1;
                return order.indexOf(a.id) - order.indexOf(b.id);
              });

              var current_page_id = $(".t-residential").data("id");
              var current_project = $.findObjectByKey(
                Object.values(localize.residentials),
                "id",
                current_page_id,
              );

              if (!$(".js-is-sasad-archive").length && current_project) {
                if (hasLegacyResidentialDatas) {
                  const current_page_sp_ids = Object.values(
                    localize.residentials || {},
                  )
                    .filter(
                      (project) =>
                        String(project.id) === String(current_page_id),
                    )
                    .map((project) => String(project.sp_id));

                  if (current_page_sp_ids.length) {
                    $delivery_in = $delivery_in.filter((e) =>
                      current_page_sp_ids.includes(String(e.id)),
                    );
                  }
                } else if (current_project.is_child) {
                  $delivery_in = $delivery_in.filter(
                    (e) => e.id == current_project.sp_id,
                  );
                }
              }

              $.each($delivery_in, function (i, e) {
                if (
                  localize.residentials[e.id] &&
                  localize.residentials[e.id].hide_technical_delivery
                ) {
                  return;
                }

                var technical_delivery_overwrite = null;
                if (localize.residentials[e.id] != undefined) {
                  technical_delivery_overwrite =
                    localize.residentials[e.id].technical_delivery_overwrite;
                }

                var cut_string_from_technical_delivery = null;
                if (localize.residentials[e.id] != undefined) {
                  cut_string_from_technical_delivery =
                    localize.residentials[e.id]
                      .cut_string_from_technical_delivery;
                }

                var prefixName = e.nev_uj != undefined ? e.nev_uj : e.nev;
                prefixName += ":";

                if (cut_string_from_technical_delivery != null) {
                  prefixName = prefixName
                    .replace(cut_string_from_technical_delivery, "")
                    .trim();
                }

                if (technical_delivery_overwrite != null) {
                  if ($delivery_in.length > 1) {
                    $(technicalDeliverySelector).append(
                      `<br> ${prefixName} ` +
                        (technical_delivery_overwrite || "-"),
                    );
                  } else {
                    showData(
                      technicalDeliverySelector,
                      technical_delivery_overwrite || "",
                    );
                  }
                } else {
                  if (e.atadas != undefined) {
                    if ($delivery_in.length > 1) {
                      $(technicalDeliverySelector).append(
                        `<br> ${prefixName} ` +
                          ($.convertDeliveryName(e.atadas) || "-"),
                      );
                    } else {
                      showData(
                        technicalDeliverySelector,
                        $.convertDeliveryName(e.atadas) || "",
                      );
                    }
                  }
                }
              });
            } else {
              showData(".js-technical-delivery", "");
              showData(".residential__datas_wrapper .js-technical-delivery", "");
            }
          }

          if ($(".t-residential").data("project") == undefined) {
            $(".js-technical-delivery").html("");
          }
        }
      }

      if (!this.reszletesDomCol2["jquery"]) {
        this.reszletesDomCol2 = $(this.reszletesDomCol2);
        this.reszletesDomCol2.html("");

        if ($("[data-showflatlist]").data("showflatlist") != true) {
          keresoAddCheckboxes(
            this.reszletesDomCol2,
            () => this.filters["kilatas"],
            (kilatasFilter) => this.setFilter("kilatas", kilatasFilter),
            (this.fulldb?.lakas ?? [])
              .map((e) => e?.kilatas_web || "")
              .filter((s) => s.length > 0)
              .flatMap((s) => s.split(";"))
              .filter((s) => s.length > 0)
              .filter($.onlyUnique),
            localize.translations.kilatas,
            "kilatas",
            undefined,
            false,
          );

          //kornyezet
          keresoAddCheckboxes(
            this.reszletesDomCol2,
            () => this.filters["kornyezet"],
            (kornyezetFilter) => this.setFilter("kornyezet", kornyezetFilter),
            this.fulldb.project
              .map((e) => e["kornyezet"])
              .filter((e) => e)
              .filter($.onlyUnique),
            localize.translations.neighbourhood,
            "kornyezet",
            undefined,
            false,
          );
        }
      }

      if (!this.reszletesDomCol3["jquery"]) {
        this.reszletesDomCol3 = $(this.reszletesDomCol3);
        this.reszletesDomCol3.html("");

        if ($("[data-showflatlist]").data("showflatlist") != true) {
          keresoAddCheckboxes(
            this.reszletesDomCol3,
            () => this.filters["tajolas_web"],
            (tajolasFilter) => this.setFilter("tajolas_web", tajolasFilter),
            ["Északi", "Déli", "Keleti", "Nyugati"],
            localize.translations.tajolas,
            "tajolas_web",
            undefined,
            false,
          );
        }
      }
    },
    //bármilyen módosítás után erre a "frissítőre" hívunk rá
    refreshResult: function () {
      this.ongoingRefresh = true;
      this.doFiltering();
      this.refreshFilterList();
      this.updateDomRoomNumRange();
      this.updateDomTeruletslider();
      this.updateDomReszletes();
      this.updateDetails();

      this.updateDomFlatlist();

      $("#flatlist table").animate({ scrollLeft: 0 }, 500);

      //do the cb
      if (this.eredmenycb) {
        var projects = [];

        this.result.forEach((r) => {
          if (r["project_id"] && projects.indexOf(r["project_id"]) == -1) {
            projects.push(r["project_id"]);
          }
        });
        projects = projects.sort();
        projects = projects
          .map((p) => {
            var hasP = this.fulldb.project.filter((dbproj) => dbproj.id == p);
            if (hasP.length == 0) {
              return null;
            }
            return hasP[0];
          })
          .filter((e) => e);

        this.eredmenycb(projects, this.result, this.fulldb, init);
        init = false;
      }

      this.ongoingRefresh = false;
    },
  };

  function showData(selector, data, fade_discountbutton = false) {
    $(selector).each(function () {
      $(this).html(data);
      $(this)
        .parent()
        .animate({ opacity: 1 }, 200, function (e) {
          if (fade_discountbutton) {
            var newWidth = $(".js-copy-width").outerWidth();
            $(".js-discounted-apartments--mod").css("width", newWidth);

            $(".js-discounted-apartments--mod").animate({ opacity: 1 }, 200);
          }
        });
    });
  }

  /* Document Ready */
  $(function () {
    if ($(".js-template-nopermission").length == 0) {
      $(document).on("click", ".js-residential-filter", function () {
        var pid = $(this).data("id");
        $(".js-residential-filter").removeClass("active");
        $(this).addClass("active");
        $.lakaskereso.setFilter("utem", pid);
      });

      $(".js-flat-order").SumoSelect({
        placeholder: localize.translations.sorting,
        csvDispCount: 2,
        captionFormat: `{ 0 } ${localize.translations.optionCaption} `,
        captionFormatAllSelected: `${localize.translations.allSelected} `,
        search: false,
        searchText: localize.translations.searchText,
        noMatch: `${localize.translations.searchTextNoMatch} "{0}"`,
      });

      if (window.location.search) {
        const url = $.deshortenLakasUrl(window.location.search.substr(1));

        if (url.sort) {
          const value = url.sort.by + (url.sort.asc == false ? "-asc" : "");
          $(".js-flat-order")[0].sumo.selectItem(value);
        }

        if ($(".js-flat-order").val()) {
          const closeButton = $(".js-flat-order").next().find("label");
          closeButton.addClass("clear");

          closeButton.on("click", function () {
            $(this).removeClass("clear");
            $($(".js-flat-order").find("option")[0]).removeAttr("disabled");

            $(".js-flat-order")[0].sumo.unSelectItem($(".js-flat-order").val());
            $(".js-flat-order")[0].sumo.selectItem(0);

            $($(".js-flat-order").find("option")[0]).attr(
              "disabled",
              "disabled",
            );

            $(".js-flat-order")[0].sumo.reload();
          });
        }
      }

      $(".js-flat-order").on("change", function () {
        if (!$(this).val()) {
          return;
        }

        $.lakaskereso.setSort("", true);

        switch ($(this).val()) {
          case "terulet_ossz":
            $.lakaskereso.setSort("terulet_ossz", true);
            break;
          case "terulet_ossz-asc":
            $.lakaskereso.setSort("terulet_ossz", false);
            break;
          case "szoba":
            $.lakaskereso.setSort("szoba", true);
            break;
          case "szoba-asc":
            $.lakaskereso.setSort("szoba", false);
            break;
          case "emelet":
            $.lakaskereso.setSort("emelet", true);
            break;
          case "emelet-asc":
            $.lakaskereso.setSort("emelet", false);
            break;
        }

        const closeButton = $(".js-flat-order").next().find("label");
        closeButton.addClass("clear");

        closeButton.on("click", function () {
          $(this).removeClass("clear");
          $($(".js-flat-order").find("option")[0]).removeAttr("disabled");

          $(".js-flat-order")[0].sumo.unSelectItem($(".js-flat-order").val());
          $(".js-flat-order")[0].sumo.selectItem(0);

          $($(".js-flat-order").find("option")[0]).attr("disabled", "disabled");

          $(".js-flat-order")[0].sumo.reload();
        });
      });

      $("body").on("click", function (e) {
        var $target = $(e.target);

        if ($(".js-detailed-filters").length) {
          if ($(".js-detailed-filters").is(":visible")) {
            if (
              !$target.parents().hasClass("search__widget_wrapper") &&
              !$target.parents().hasClass("js-detailed-filters")
            ) {
              $(".js-detailed-filters").slideToggle("fast");
              $(this).toggleClass("open");
              $("body").toggleClass("detailed-filters-open");
            }
          }
        }
      });

      $(document).on("click", ".flat-url", function (e) {
        e.stopPropagation();
      });

      $(document).on("click", ".js-table-offer", function (e) {
        const target = $(e.target);

        if (
          !target.hasClass("flatSelector") &&
          !target.hasClass("floor__plan_image") &&
          !target.hasClass("js-image-preview") &&
          !target.hasClass("checkbox-label") &&
          !target.hasClass("checkbox-item") &&
          !target.hasClass("tour3d-wrapper") &&
          !target.hasClass("tour3d-link")
        ) {
          const url = $(this).find(".flat-url").attr("href");
          Cookies.set(`filter_history`, location.href);
          window.open(url, "_blank");
        }
      });

      document.addEventListener("click", function (event) {
        const dropdownTitle =
          document.getElementsByClassName("dropdown__title");

        for (let index = 0; index < dropdownTitle.length; index++) {
          const element = dropdownTitle[index];
          const dropdownInner = dropdownTitle[index].nextElementSibling;

          const outsideClick =
            typeof event.composedPath === "function" &&
            !event.composedPath().includes(element);
          const outsideInner =
            typeof event.composedPath === "function" &&
            !event.composedPath().includes(dropdownInner);

          if (
            outsideInner &&
            outsideClick &&
            element.classList.contains("active")
          ) {
            $(element).toggleClass("active");
            $(element).next().slideToggle("fast");
          }
        }
      });

      $.lakaskereso.szobarangeDom = document.getElementById("room-range");
      $.lakaskereso.teruletsliderDom = document.getElementById("area-slider");
      $.lakaskereso.lakasokDom = document.getElementById("flatlist");
      $.lakaskereso.lakoparkokDom = document.getElementById("residential-tabs");
      $.lakaskereso.reszletesDomCol1 = document.getElementById(
        "detailed-filters-col1",
      );
      $.lakaskereso.reszletesDomCol2 = document.getElementById(
        "detailed-filters-col2",
      );
      $.lakaskereso.reszletesDomCol3 = document.getElementById(
        "detailed-filters-col3",
      );
      $.lakaskereso.residentialDetails = document.getElementById(
        "residential-details",
      );
      $.lakaskereso.districtFilter =
        document.getElementById("district__filter");
      $.lakaskereso.residentialFilter =
        document.getElementById("residential-filter");

      $.lakaskereso.eredmenycb = function (projects, flats, db, init = false) {
        if ($(".js-widget-loader").hasClass("loading")) {
          $(".js-widget-loader").removeClass("loading");
          $(".js-widget-loader").fadeOut(400, function () {
            $(".js-widget-filters-wrapper").addClass("active");
          });
        }

        if ($(".js-is-sasad-archive").length) {
          $(".js-sasad-childs").each(function () {
            const $this = $(this);
            var current_page_id = $(this).data("id");
            var sp_ids = $.getSpIdsByPageId(current_page_id);

            var free = 0;

            if (sp_ids.length) {
              $.lakaskereso.fulldb.lakas.forEach(function (item) {
                if (
                  sp_ids.includes(item.project_id) &&
                  item.status == "Szabad"
                ) {
                  free++;
                }
              });

              if (free === 0) {
                $this
                  .find(".section-residential-datas-sasad__wrapper__item__text")
                  .html("-");
              } else {
                $this.find(".js-free-flats-sasad-child").text(free);
              }
            } else {
              $this
                .find(".section-residential-datas-sasad__wrapper__item__text")
                .html("-");
            }
          });
        }

        /* marina city project cards flat numer */
        if (
          $(".js-number-of-flats-card").length &&
          $(".project__card_content__flats").length
        ) {
          $(".project__card_content__flats").each(function () {
            const $this = $(this);
            var current_page_id = $(this).data("id");
            var current_project = $.findObjectByKey(
              Object.values(localize.residentials),
              "id",
              current_page_id,
            );

            var free = 0;

            $.lakaskereso.fulldb.lakas.forEach(function (item) {
              if (
                item.project_id === current_project.sp_id &&
                item.status == "Szabad"
              ) {
                free++;
              }
            });

            if (free === 0) {
              $this.find(".project__card_content__flats__span").html("-");
            } else {
              $this.find(".js-number-of-flats-card").text(free);
            }
          });
        }

        if ($(".js-ready-to-move-in").length) {
          var $read_to_move_in = cordia_flat_db.lakas
            .filter((e) => e.azonnal_koltozheto == "1")
            .map((e) => e.project_id)
            .filter(jQuery.onlyUnique);

          if ($(".js-residential-pager").length) {
            $(".js-residential-pager").each(function (index) {
              const listItems = $(this).find(".swiper-slide");

              //js-freeflats
              $.each(listItems, function (i, e) {
                var $projects = $(this).find(".js-freeflats").data("projects");
                if ($projects == undefined) {
                  $(this).remove();
                  return;
                }

                if ($projects.length != 1) {
                  $(this).remove();
                  return;
                }

                const isElementFound = $projects.some((element) =>
                  $read_to_move_in.includes(element),
                );

                if (!isElementFound) {
                  $(this).remove();
                  return;
                }
              });
            });
          }

          $.fn.matchHeight._applyDataApi();
          //$.makeResidentialPager();

          $(".js-fullscreen-loader").fadeOut(200, function () {
            $(".js-ready-to-move-in").removeClass("loading");
          });
        }

        if ($(".js-t-residential").length && this.result.length && !init) {
          var current_page_id = $(".t-residential").data("id");
          var current_project = $.findObjectByKey(
            Object.values(localize.residentials),
            "id",
            current_page_id,
          );
          const hasLegacyResidentialDatas =
            $(".residential__datas_wrapper").length > 0;
          const currentPageSpIds = Object.values(localize.residentials || {})
            .filter((project) => String(project.id) === String(current_page_id))
            .map((project) => String(project.sp_id));

          var current_result = this.result;
          if (currentPageSpIds.length > 0) {
            current_result = this.result.filter(
              (p) => currentPageSpIds.includes(String(p.project_id)),
            );
          }
          showData(
            ".js-number-of-flats",
            `${current_result.length} ${$.pluralize(
              localize.translations.flat,
              this.lakasok.length,
            )} `,
            true,
          );
          //const terulet = this.result.map((l) => parseFloat(l.terulet_ossz)).filter((terulet) => !isNaN(terulet));

          const terulet = current_result
            .map((l) => parseFloat(l.terulet_ossz))
            .filter((terulet) => !isNaN(terulet));

          const minTerulet = Math.ceil(Math.min(...terulet));
          const maxTerulet = Math.floor(Math.max(...terulet));
          showData(".js-min-area", minTerulet);
          showData(".js-max-area", maxTerulet);
          if (current_project) {
            showData(".js-environment", current_project.environment);
            showData(
              ".js-energetic-classification",
              current_project.energy_classification,
            );
          }

          if (hasLegacyResidentialDatas && currentPageSpIds.length) {
            const scopedResult = this.result.filter((item) =>
              currentPageSpIds.includes(String(item.project_id)),
            );

            showData(
              ".residential__datas_wrapper .js-number-of-flats",
              `${scopedResult.length} ${$.pluralize(
                localize.translations.flat,
                scopedResult.length,
              )} `,
              true,
            );

            const scopedTerulet = scopedResult
              .map((item) => parseFloat(item.terulet_ossz))
              .filter((terulet) => !isNaN(terulet));

            if (scopedTerulet.length) {
              const scopedMinTerulet = Math.ceil(Math.min(...scopedTerulet));
              const scopedMaxTerulet = Math.floor(Math.max(...scopedTerulet));
              showData(
                ".residential__datas_wrapper .js-min-area",
                scopedMinTerulet,
              );
              showData(
                ".residential__datas_wrapper .js-max-area",
                scopedMaxTerulet,
              );
            }

            if (current_project) {
              showData(
                ".residential__datas_wrapper .js-environment",
                current_project.environment,
              );
              showData(
                ".residential__datas_wrapper .js-energetic-classification",
                current_project.energy_classification,
              );
            }
          }
        }

        if ($(".js-t-residential").length && this.result.length && init) {
          var current_page_id = $(".t-residential").data("id");
          var current_project = $.findObjectByKey(
            Object.values(localize.residentials),
            "id",
            current_page_id,
          );
          const hasLegacyResidentialDatas =
            $(".residential__datas_wrapper").length > 0;
          const currentPageSpIds = Object.values(localize.residentials || {})
            .filter((project) => String(project.id) === String(current_page_id))
            .map((project) => String(project.sp_id));
          var current_result = this.result;
          if ($(".js-number-of-flats").length) {
            if (currentPageSpIds.length > 0) {
              current_result = this.result.filter(
                (p) => currentPageSpIds.includes(String(p.project_id)),
              );
            }
            if (current_result.length === 0) {
              $(".js-number-of-flats").parent().html("-");
            }
          }

          if (hasLegacyResidentialDatas && currentPageSpIds.length) {
            const scopedResult = this.result.filter((item) =>
              currentPageSpIds.includes(String(item.project_id)),
            );

            if (scopedResult.length === 0) {
              $(".residential__datas_wrapper .js-number-of-flats")
                .parent()
                .html("-");
            }
          }
        }

        if ($(".js-flat-types").length && $(".t-residential").length && !init) {
          const residentialId = $(".t-residential").data("project");
          var current_page_id = $(".t-residential").data("id");
          var current_project = $.findObjectByKey(
            Object.values(localize.residentials),
            "id",
            current_page_id,
          );

          if (residentialId) {
            cordiaAPI
              .get("/sf/getflattypes", {
                params: {
                  lang: $.langCookie,
                },
              })
              .then((response) => {
                const projects = response.data[residentialId];

                let sum = {};

                for (const prop in projects) {
                  let project = projects[prop];
                  if (
                    current_project &&
                    prop != current_project.sp_id &&
                    current_project.is_child
                  ) {
                    continue;
                  }

                  for (const key in project) {
                    if (sum.hasOwnProperty(key)) {
                      sum[key]["count"] =
                        parseInt(sum[key]["count"]) +
                        parseInt(project[key]["count"]);
                      sum[key]["minValue"] =
                        parseInt(sum[key]["minValue"]) <
                        parseInt(project[key]["minValue"])
                          ? parseInt(sum[key]["minValue"])
                          : parseInt(project[key]["minValue"]);
                      sum[key]["minValueEur"] =
                        parseInt(sum[key]["minValueEur"]) <
                        parseInt(project[key]["minValueEur"])
                          ? parseInt(sum[key]["minValueEur"])
                          : parseInt(project[key]["minValueEur"]);
                    } else {
                      sum[key] = {
                        count: parseInt(project[key]["count"]),
                        minValue: parseInt(project[key]["minValue"]),
                        minValueEur: parseInt(project[key]["minValueEur"]),
                      };
                    }
                  }
                }

                for (const key in sum) {
                  if (sum[key]["count"] <= 0) {
                    continue;
                  }

                  if (
                    current_project &&
                    current_project.flat_prices_huf[key - 1] != null &&
                    current_project.flat_prices_huf[key - 1] != ""
                  ) {
                    sum[key]["minValue"] =
                      current_project.flat_prices_huf[key - 1];
                  }

                  if (
                    current_project &&
                    current_project.flat_prices_eur[key - 1] != null &&
                    current_project.flat_prices_eur[key - 1] != ""
                  ) {
                    sum[key]["minValueEur"] =
                      current_project.flat_prices_eur[key - 1];
                  }

                  let flat = this.result.find((e) => e.szoba == key);

                  if (current_project && current_project.is_child) {
                    flat = this.result
                      .filter((p) => p.project_id == current_project.sp_id)
                      .find((e) => e.szoba == key);
                  }

                  let colText = "col";
                  if (Object.keys(sum).length === 1) {
                    colText = "col-lg-4";
                  }

                  const isSingleFlat = sum[key]["count"] === 1;

                  let card =
                    `<div class="` +
                    colText +
                    `"> ` +
                    `<a ` +
                    (sum[key]["count"] > 0
                      ? `href="${
                          localize.flatSearchUrl +
                          `?${$.urlParams}&r=${key}-${key}`
                        }"`
                      : "") +
                    ` class="card__flattypes js-mh-card-flattypes">` +
                    `<div class="flattype__image">` +
                    `<img src="` +
                    (flat
                      ? `${localize.imgurl}${flat.id.toLowerCase()}.jpg"`
                      : "") +
                    `alt="" class="img-fluid">` +
                    `</div> ` +
                    `<div class="flattype__content">` +
                    `<h4>${
                      localize.translations.flatTypes.flatTypeText[key - 1]
                    } (${sum[key]["count"]} ${
                      localize.translations.pieces
                    })</h4>` +
                    `${
                      current_project.show_flat_types_prices
                        ? `<p class="flat__price js-mh-flat-price"> ${
                            $.langCookie == "hu"
                              ? `${
                                  sum[key]["minValue"] &&
                                  current_project.show_huf_prices
                                    ? sum[key]["minValue"]
                                        .toString()
                                        .replace(
                                          /\B(?!\.\d*)(?=(\d{3})+(?!\d))/g,
                                          ".",
                                        ) + (isSingleFlat ? " Ft" : " Ft-tól")
                                    : ""
                                }${
                                  sum[key]["minValue"] &&
                                  current_project.show_huf_prices &&
                                  sum[key]["minValueEur"] &&
                                  current_project.show_eur_prices
                                    ? " \\ "
                                    : ""
                                } ${
                                  sum[key]["minValueEur"] &&
                                  current_project.show_eur_prices
                                    ? sum[key]["minValueEur"].toString() +
                                      (isSingleFlat ? " EUR" : " EUR-tól")
                                    : ""
                                }`
                              : `${
                                  sum[key]["minValue"] &&
                                  current_project.show_huf_prices
                                    ? (isSingleFlat ? "" : "from ") +
                                      sum[key]["minValue"]
                                        .toString()
                                        .replace(
                                          /\B(?!\.\d*)(?=(\d{3})+(?!\d))/g,
                                          ".",
                                        ) +
                                      " Ft"
                                    : ""
                                }${
                                  sum[key]["minValue"] &&
                                  current_project.show_huf_prices &&
                                  sum[key]["minValueEur"] &&
                                  current_project.show_eur_prices
                                    ? " \\ "
                                    : ""
                                }${
                                  sum[key]["minValueEur"] &&
                                  current_project.show_eur_prices
                                    ? (isSingleFlat ? "" : "from ") +
                                      sum[key]["minValueEur"].toString() +
                                      " EUR"
                                    : ""
                                }`
                          } </p>`
                        : ``
                    }` +
                    (sum[key]["count"] > 0
                      ? `<p class="flat__quantity"> ${
                          localize.translations.flatTypes.flatTypeLinkText[
                            key - 1
                          ]
                        } `
                      : ` <p class="flat__quantity flat__quantity--sold-out"> ${localize.translations.sold_out} `) +
                    `</p> ` +
                    `</div> ` +
                    `</a> ` +
                    `</div> `;

                  $(".js-flat-types").append(card);
                }

                if (!jQuery.isEmptyObject(sum)) {
                  $(".js-flat-types-wrapper").animate(
                    { opacity: 1 },
                    300,
                    function () {
                      $(".js-mh-card-flattypes").matchHeight({});
                      $(".js-mh-flat-price").matchHeight({});
                    },
                  );
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          }
        }

        /* Similar flats */

        if ($(".js-similar-flats").length && $(".t-flats").length && !init) {
          const residentialId = $(".t-flats").data("project").toString();

          if (residentialId) {
            var project_id = $.findObjectByKey(
              $.lakaskereso.fulldb.project,
              "lakopark_id",
              residentialId,
            ).id;

            if (project_id) {
              const numOfRooms = $(".t-flats").data("rooms").toString();
              const currentFlat = $(".t-flats").data("flatcode").toString();

              var similar_flats = $.lakaskereso.fulldb.lakas
                .filter(
                  (e) =>
                    e.project_id == project_id &&
                    e.szoba == numOfRooms &&
                    (e.lakaskod != undefined ? e.lakaskod : e.nev) != currentFlat,
                )
                .sort(function () {
                  return Math.round(Math.random()) - 0.5;
                })
                .slice(0, 3)
                .sort(function (a, b) {
                  if (a.nev > b.nev) {
                    return 1;
                  }
                  if (a.nev < b.nev) {
                    return -1;
                  }
                  return 0;
                });

              if (!$.isEmptyObject(similar_flats)) {
                var currentResidential = $(".js-residential-to-copy").html();
                var currentAddress = $(".js-address-to-copy").clone().html();
                currentAddress = currentAddress.replace(
                  "icon_pin.svg",
                  "pin_orange.svg",
                );

                $.each(similar_flats, function (index, value) {
                  const area =
                    value["terulet_ossz"] +
                    ` ${$.langCookie == "ru" ? " кв.м" : " m<sup>2</sup>"} `;
                  let card = html`
                    <div class="col">
                      <div
                        class="card__similar_flat"
                        data-mh="mh-card-similar-flat"
                      >
                        <a
                          class="card__fake_link"
                          href="${localize.residentials[project_id]
                            .link}${value.lakaskod != undefined
                            ? value.lakaskod
                            : value.nev}"
                        ></a>
                        <div class="similar__flat_image">
                          <img
                            src="${localize.imgurl}${value.id.toLowerCase()}.jpg"
                            alt=""
                            class="img-fluid"
                          />
                        </div>
                        <div class="similar__flat_content">
                          <h4>${value.nev} - <span>${area}</span></h4>
                          <div class="card__separator"></div>
                          <div class="card__extra_info">
                            <div class="residential__name">
                              ${currentResidential}
                            </div>

                            <div class="residential__address">
                              ${currentAddress}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  `;
                  $(".js-similar-flats").append(card);
                });

                $(".js-similar-flats-wrapper").animate({ opacity: 1 }, 300);
              } else {
                $(".js-similar-flats-wrapper").remove();
              }
            }
          }
        }

        /* Listás kereső */
        if ($(".t-flats-search").length) {
          $(".js-residentials-and-flats").text(
            `${this.result.length} ${$.pluralize(
              localize.translations.freeflats,
              this.result.length,
            )} `,
          );
          $(".js-residentials-and-flats-favs").text(
            `${this.result.length} ${$.pluralize(
              localize.translations.flat,
              this.result.length,
            )} `,
          );

          var utem = $.lakaskereso.filters.utem;

          $(".sticky-title").text(
            $(".js-residential-filter.active span").text(),
          );

          if ($.langCookie == "ru") {
            $(".js-number-of-flats").text(
              `${this.lakasok.length} свободных ${$(
                ".js-residential-filter.active span",
              ).text()} квартир`,
            );
          } else {
            $(".js-number-of-flats").text(
              `${this.lakasok.length} ${
                window.localize.translations.freeflats_2
              } ${$(".js-residential-filter.active span").text()} ${$.pluralize(
                localize.translations.flat,
                this.lakasok.length,
              )} `,
            );
          }

          if (
            utem != undefined &&
            window.localize.residentials[$.lakaskereso.filters.utem] !=
              undefined
          ) {
            if (window.localize.residentials[utem]["link"] != undefined) {
              $(".js-residential-link").show();
              $(".js-residential-link")
                .attr("href", window.localize.residentials[utem]["link"])
                .find("span")
                .text(window.localize.residentials[utem].projekt_nev);
            }
          } else {
            $(".js-residential-link").hide();
          }
        }

        /* Térképes kereső */
        if ($(".t-map-search").length) {
          $.filterMarkers(
            projects
              .map((e) => e.lakopark_id)
              .map((e) =>
                e.toString().includes("_")
                  ? e.toString().split("_")[0]
                  : e.toString(),
              ),
            projects.map((e) => (e.nev_uj != undefined ? e.nev_uj : e.nev)),
          );

          $.filterMapLayers($.lakaskereso.filters.kerulet);

          if (
            projects &&
            typeof $.lakaskereso.filters.kerulet !== "undefined"
          ) {
            let activeDistricts = [];

            projects.forEach((project) => {
              const district = project.kerulet;

              if (!activeDistricts.includes(project.kerulet)) {
                activeDistricts.push(district);
              }
            });

            $.filterMapLayers(
              $.lakaskereso.filters.kerulet.filter((e) =>
                activeDistricts.includes(e),
              ),
            );
          }

          if ($.lakaskereso.filters.szoba || $.lakaskereso.filters.terulet) {
            $(".js-active-filters").addClass("active");
            $(".js-rooms-filter small,.js-area-filter small").html();

            if ($.lakaskereso.filters.szoba) {
              $(".js-rooms-filter small")
                .html($.lakaskereso.filters.szoba.join("-"))
                .parent()
                .addClass("active");
            } else {
              $(".js-rooms-filter").removeClass("active");
            }

            if ($.lakaskereso.filters.terulet) {
              $(".js-area-filter small")
                .html($.lakaskereso.filters.terulet.join("-"))
                .parent()
                .addClass("active");
            } else {
              $(".js-area-filter").removeClass("active");
            }
          } else {
            $(".js-active-filters,.js-area-filter,js-rooms-filter").removeClass(
              "active",
            );
          }
        }

        $("#no-result-msg").hide();

        if (!$.lakaskereso.result.length) {
          $("#no-result-msg").show();
        }
        if ($(".js-t-residential").length && this.result.length && !init) {
          var current_page_id = $(".t-residential").data("id");
          var current_project = $.findObjectByKey(
            Object.values(localize.residentials),
            "id",
            current_page_id,
          );
          const currentPageSpIds = Object.values(localize.residentials || {})
            .filter((project) => String(project.id) === String(current_page_id))
            .map((project) => String(project.sp_id));

          if (current_project && current_project.is_child) {
            flats = flats.filter((p) => p.project_id == current_project.sp_id);
          } else if (currentPageSpIds.length > 0) {
            flats = flats.filter((p) => currentPageSpIds.includes(String(p.project_id)));
          }
        }
        $(".js-flatsearch-button .button__meta").html(
          `(${flats.length} ${$.pluralize(
            localize.translations.flat,
            flats.length,
          )})`,
        );

        if (init) {
          if (
            localStorage.getObj("selected") != null &&
            $(".t-flats-search").length
          ) {
            $(".js-selected-flats").text(
              `${
                $.lakaskereso.selected.length > 0
                  ? "(" +
                    $.lakaskereso.selected.length +
                    " " +
                    $.pluralize(
                      localize.translations.flat,
                      $.lakaskereso.selected.length,
                    ) +
                    ")"
                  : ""
              } `,
            );
          }

          $(".dropdown__inner>li>.checkbox-group>.checkbox-item").each(
            function () {
              const dropdown = $(this).closest(".dropdown");
              const dropdownLabel = $(dropdown).prev().text();
              const dropdownTitle = $(dropdown).find(".dropdown__title");
              const group = $(this).closest(".checkbox-group");

              let checked = [];

              $(group)
                .find("input:checked")
                .each(function () {
                  checked.push($(this).next().text());
                });

              let title = dropdownLabel;

              $(dropdownTitle).removeClass("selected");

              if (checked.length) {
                $(dropdownTitle).addClass("selected");

                if (checked.length === 1) {
                  title = checked[0];
                }

                if (checked.length > 1) {
                  title = checked.length + " " + localize.translations.selected;
                }
              }

              $(dropdownTitle).text(title);
            },
          );
        }
      };
      $.urlParams = null;

      $.lakaskereso.paramchangecb = function (params) {
        $.urlParams = $.shortenLakasUrl(params);
        //url valtoztatas
        if ($(".t-flats-search").length) {
          window.history.replaceState(
            {},
            null,
            window.location.pathname +
              (Object.keys(params) == 0 ? "" : "?" + $.urlParams),
          );
        }
      };
      //init;
      $.lakaskereso.initDb(
        $.deshortenLakasUrl(window.location.search.substr(1)),
      );
    }
  });
})(jQuery);
